// Custom Spanish word list generated from top 10000 words of RAE, most common names, removing words with diacritics and other minor adjustments
export const SpanishWordList = [
  "abajo",
  "abandona",
  "abandonada",
  "abandonado",
  "abandonar",
  "abandono",
  "abanico",
  "abarca",
  "abastecimiento",
  "abc",
  "abdomen",
  "abel",
  "abierta",
  "abiertamente",
  "abiertas",
  "abierto",
  "abiertos",
  "abismo",
  "abogado",
  "abogados",
  "abordar",
  "aborto",
  "abrazo",
  "abre",
  "abren",
  "abriendo",
  "abrieron",
  "abrigo",
  "abril",
  "abrir",
  "abrirse",
  "absoluta",
  "absolutamente",
  "absoluto",
  "abstracto",
  "absurda",
  "absurdo",
  "abuela",
  "abuelo",
  "abuelos",
  "abundan",
  "abundancia",
  "abundante",
  "abundantes",
  "abuso",
  "abusos",
  "acaba",
  "acababa",
  "acabado",
  "acabamos",
  "acaban",
  "acabar",
  "acabaron",
  "acabo",
  "academia",
  "acaso",
  "acceder",
  "acceso",
  "accidente",
  "accidentes",
  "acciones",
  "accionistas",
  "aceite",
  "aceites",
  "acelerar",
  "acento",
  "acepta",
  "aceptable",
  "aceptada",
  "aceptado",
  "aceptan",
  "aceptar",
  "acera",
  "acerca",
  "acercaba",
  "acercamiento",
  "acercan",
  "acercarse",
  "acero",
  "acierto",
  "aclara",
  "aclarar",
  "acogida",
  "aconsejable",
  "acontecimiento",
  "acontecimientos",
  "acordado",
  "acorde",
  "acoso",
  "acosta",
  "acostumbrado",
  "acostumbrados",
  "acta",
  "actitud",
  "actitudes",
  "activa",
  "activamente",
  "actividad",
  "actividades",
  "activo",
  "activos",
  "acto",
  "actor",
  "actores",
  "actos",
  "actriz",
  "actuaciones",
  "actuado",
  "actual",
  "actuales",
  "actualidad",
  "actualmente",
  "actuando",
  "actuar",
  "acude",
  "acuden",
  "acudieron",
  "acudir",
  "acuerdas",
  "acuerdo",
  "acuerdos",
  "acumulado",
  "acusa",
  "acusaciones",
  "acusado",
  "acusados",
  "acusan",
  "adam",
  "adaptarse",
  "adecuada",
  "adecuadamente",
  "adecuadas",
  "adecuado",
  "adecuados",
  "adelantado",
  "adelantar",
  "adelante",
  "adentro",
  "adicional",
  "adicionales",
  "adivinar",
  "adjunto",
  "administraciones",
  "administrador",
  "administrar",
  "administrativa",
  "administrativas",
  "administrativo",
  "administrativos",
  "admirable",
  "admite",
  "admitir",
  "adn",
  "adolescencia",
  "adolescente",
  "adolescentes",
  "adolfo",
  "adonde",
  "adopta",
  "adoptada",
  "adoptado",
  "adoptar",
  "adquiere",
  "adquieren",
  "adquirido",
  "adquirir",
  "aduanas",
  "adulta",
  "adulto",
  "adultos",
  "adversario",
  "adversarios",
  "advertencia",
  "advertido",
  "advertir",
  "advierte",
  "aeropuerto",
  "afecta",
  "afectada",
  "afectadas",
  "afectado",
  "afectados",
  "afectan",
  "afectar",
  "afecto",
  "aficionado",
  "aficionados",
  "afiliados",
  "afirma",
  "afirmaba",
  "afirmaciones",
  "afirman",
  "afirmar",
  "afortunadamente",
  "africa",
  "africano",
  "africanos",
  "afrontar",
  "afuera",
  "afueras",
  "agencia",
  "agencias",
  "agenda",
  "agente",
  "agentes",
  "agosto",
  "agotado",
  "agotamiento",
  "agradable",
  "agradecimiento",
  "agraria",
  "agrega",
  "agregado",
  "agregar",
  "agresiones",
  "agresiva",
  "agresividad",
  "agresivo",
  "agricultores",
  "agricultura",
  "agrupaciones",
  "agua",
  "aguantar",
  "aguas",
  "aguda",
  "agudo",
  "aguilar",
  "aguirre",
  "aguja",
  "agujero",
  "agujeros",
  "ahmed",
  "ahora",
  "ahorro",
  "ahorros",
  "aicha",
  "aina",
  "ainara",
  "ainhoa",
  "aire",
  "aires",
  "aislada",
  "aislado",
  "aislados",
  "aislamiento",
  "aitor",
  "ajedrez",
  "ajena",
  "ajenas",
  "ajeno",
  "ajenos",
  "ajo",
  "ajuste",
  "ala",
  "alarma",
  "alas",
  "alba",
  "albert",
  "alberto",
  "alcalde",
  "alcaldes",
  "alcance",
  "alcanza",
  "alcanzaba",
  "alcanzado",
  "alcanzan",
  "alcanzar",
  "alcanzaron",
  "alcoba",
  "alcohol",
  "alcoholismo",
  "aldea",
  "alegre",
  "aleix",
  "aleja",
  "alejado",
  "alejandra",
  "alejandro",
  "alejarse",
  "alemana",
  "alemanes",
  "alemania",
  "alerta",
  "alex",
  "alexander",
  "alfa",
  "alfombra",
  "alfonso",
  "alfredo",
  "algo",
  "alguien",
  "alguna",
  "algunas",
  "alguno",
  "algunos",
  "aliado",
  "aliados",
  "alianza",
  "alianzas",
  "alicante",
  "alicia",
  "aliento",
  "alimentaria",
  "alimento",
  "alimentos",
  "aliviar",
  "alivio",
  "allende",
  "alma",
  "almacenamiento",
  "almacenes",
  "almas",
  "almirante",
  "almuerzo",
  "almunia",
  "alojamiento",
  "alonso",
  "alquiler",
  "alrededor",
  "alrededores",
  "alta",
  "altamente",
  "altar",
  "altas",
  "alteraciones",
  "alterar",
  "alternativa",
  "alternativas",
  "alto",
  "altos",
  "altura",
  "alturas",
  "alude",
  "aluminio",
  "alumno",
  "alumnos",
  "alvarado",
  "alvarez",
  "alvaro",
  "alza",
  "ama",
  "amaba",
  "amable",
  "amada",
  "amado",
  "amaia",
  "amalia",
  "amanecer",
  "amante",
  "amantes",
  "amar",
  "amargo",
  "amargura",
  "amarilla",
  "amarillas",
  "amarillo",
  "amaya",
  "ambas",
  "ambiciones",
  "ambicioso",
  "ambiental",
  "ambientales",
  "ambiente",
  "ambientes",
  "ambos",
  "amelia",
  "amenaza",
  "amenazas",
  "american",
  "americana",
  "americano",
  "americanos",
  "amiga",
  "amigas",
  "amigo",
  "amigos",
  "amina",
  "amir",
  "amira",
  "amistad",
  "amistades",
  "amo",
  "amor",
  "amores",
  "amorosa",
  "amparo",
  "amplia",
  "ampliamente",
  "ampliar",
  "amplias",
  "amplio",
  "amplios",
  "amplitud",
  "ana",
  "analistas",
  "analiza",
  "analizar",
  "ancha",
  "ancho",
  "anciana",
  "anciano",
  "ancianos",
  "anda",
  "andaba",
  "andaluz",
  "andaluza",
  "andan",
  "andar",
  "ander",
  "andes",
  "andino",
  "andrea",
  "anexo",
  "angel",
  "angeles",
  "anguita",
  "angustia",
  "angustias",
  "anillo",
  "animal",
  "animales",
  "aniversario",
  "anna",
  "anoche",
  "anselmo",
  "ansiedad",
  "ante",
  "antecedentes",
  "antemano",
  "antena",
  "antepasados",
  "anterior",
  "anteriores",
  "anterioridad",
  "anteriormente",
  "antes",
  "anti",
  "anticuerpos",
  "antigua",
  "antiguas",
  "antiguo",
  "antiguos",
  "antoni",
  "antonia",
  "antonio",
  "anual",
  "anuales",
  "anualmente",
  "anuncia",
  "anunciaba",
  "anunciada",
  "anunciado",
  "anunciar",
  "anunciaron",
  "anuncio",
  "anuncios",
  "aparato",
  "aparatos",
  "aparece",
  "aparecen",
  "aparecer",
  "aparecido",
  "aparecieron",
  "aparente",
  "aparentemente",
  "apariencia",
  "apartado",
  "apartados",
  "apartamento",
  "aparte",
  "apellido",
  "apellidos",
  "apenas",
  "apertura",
  "apetito",
  "aplausos",
  "aplica",
  "aplicaciones",
  "aplicada",
  "aplicado",
  "aplican",
  "aplicando",
  "aplicar",
  "aplicarse",
  "aporta",
  "aportaciones",
  "aportan",
  "aportar",
  "aporte",
  "aportes",
  "apoya",
  "apoyada",
  "apoyado",
  "apoyan",
  "apoyar",
  "apoyo",
  "apoyos",
  "aprecia",
  "apreciar",
  "aprende",
  "aprender",
  "aprendido",
  "aprendizaje",
  "aprobada",
  "aprobado",
  "aprobar",
  "apropiado",
  "aprovecha",
  "aprovechamiento",
  "aprovechando",
  "aprovechar",
  "aproximadamente",
  "apuesta",
  "apunta",
  "apuntan",
  "aquel",
  "aquella",
  "aquellas",
  "aquello",
  "aquellos",
  "aquiles",
  "araceli",
  "arafat",
  "aranzazu",
  "arce",
  "archivo",
  "archivos",
  "arco",
  "arcos",
  "arena",
  "arenas",
  "argelia",
  "argentina",
  "argentinas",
  "argentino",
  "argentinos",
  "argumento",
  "argumentos",
  "ariadna",
  "arias",
  "ariel",
  "aritz",
  "arma",
  "armada",
  "armadas",
  "armado",
  "armados",
  "armamento",
  "armando",
  "armario",
  "armas",
  "arnau",
  "aroma",
  "arquitecto",
  "arquitectos",
  "arquitectura",
  "arranca",
  "arranque",
  "arrastra",
  "arreglar",
  "arreglo",
  "arriba",
  "arroyo",
  "arroz",
  "arte",
  "arterial",
  "artes",
  "artesanos",
  "articular",
  "artificial",
  "artificiales",
  "artista",
  "artistas",
  "arturo",
  "arzobispo",
  "asalto",
  "asamblea",
  "ascendente",
  "ascenso",
  "ascensor",
  "asciende",
  "asco",
  "asegura",
  "aseguraba",
  "asegurado",
  "aseguran",
  "asegurar",
  "aseguraron",
  "asesinado",
  "asesinato",
  "asesinatos",
  "asesino",
  "asesinos",
  "asesor",
  "asesores",
  "asia",
  "asiento",
  "asientos",
  "asier",
  "asilo",
  "asimismo",
  "asistencia",
  "asistente",
  "asistentes",
  "asistido",
  "asistieron",
  "asistir",
  "asma",
  "asociaciones",
  "asociada",
  "asociadas",
  "asociado",
  "asociados",
  "asoma",
  "asombro",
  "aspecto",
  "aspectos",
  "aspira",
  "aspiraciones",
  "aspirantes",
  "aspirar",
  "asturias",
  "asume",
  "asumido",
  "asumir",
  "asunto",
  "asuntos",
  "asustado",
  "atacar",
  "ataque",
  "ataques",
  "atardecer",
  "atenas",
  "atender",
  "atendiendo",
  "atenta",
  "atentado",
  "atentados",
  "atentamente",
  "atento",
  "atiende",
  "atlanta",
  "atletas",
  "atletismo",
  "atractiva",
  "atractivo",
  "atractivos",
  "atraer",
  "atravesar",
  "atraviesa",
  "atreve",
  "atrevido",
  "atributos",
  "atribuye",
  "audiencia",
  "audiovisual",
  "auditorio",
  "auge",
  "augusto",
  "aula",
  "aulas",
  "aumenta",
  "aumentado",
  "aumentan",
  "aumentando",
  "aumentar",
  "aumento",
  "aumentos",
  "aunque",
  "aurora",
  "ausencia",
  "ausente",
  "australia",
  "austria",
  "auto",
  "autobuses",
  "autopista",
  "autor",
  "autora",
  "autores",
  "autoridad",
  "autoridades",
  "autorizado",
  "autos",
  "auxiliar",
  "auxilio",
  "avance",
  "avances",
  "avanza",
  "avanzada",
  "avanzado",
  "avanzando",
  "avanzar",
  "ave",
  "avenida",
  "aventura",
  "aventuras",
  "averiguar",
  "aves",
  "avila",
  "aviones",
  "aviraneta",
  "aviso",
  "ayala",
  "ayer",
  "ayuda",
  "ayudado",
  "ayudan",
  "ayudante",
  "ayudar",
  "ayudas",
  "ayuntamiento",
  "ayuntamientos",
  "azar",
  "aznar",
  "azul",
  "azules",
  "azulgrana",
  "bachillerato",
  "bacon",
  "bacterias",
  "bagdad",
  "bailar",
  "baile",
  "bailes",
  "baja",
  "bajaba",
  "bajado",
  "bajando",
  "bajar",
  "bajas",
  "bajo",
  "bajos",
  "bala",
  "balance",
  "balanza",
  "balas",
  "baleares",
  "ballet",
  "baloncesto",
  "banca",
  "bancaria",
  "bancarias",
  "bancario",
  "banco",
  "bancos",
  "banda",
  "bandas",
  "bandeja",
  "bandera",
  "banderas",
  "bando",
  "banesto",
  "banqueros",
  "bar",
  "barajas",
  "barato",
  "barba",
  "barça",
  "barcelona",
  "barco",
  "barcos",
  "bares",
  "barra",
  "barranco",
  "barrera",
  "barreras",
  "barrio",
  "barrionuevo",
  "barrios",
  "barro",
  "barroco",
  "basa",
  "basada",
  "basado",
  "basados",
  "base",
  "bases",
  "basta",
  "bastaba",
  "bastante",
  "bastantes",
  "basura",
  "bata",
  "batalla",
  "batallas",
  "batasuna",
  "batir",
  "bautista",
  "beach",
  "beatriz",
  "bebe",
  "beber",
  "bebida",
  "bebidas",
  "becas",
  "belga",
  "bella",
  "bellas",
  "belleza",
  "bello",
  "belloch",
  "beneficiarios",
  "beneficio",
  "beneficios",
  "benito",
  "berlusconi",
  "bernal",
  "bernardo",
  "berta",
  "beso",
  "besos",
  "bestia",
  "betis",
  "biblia",
  "biblioteca",
  "bibliotecas",
  "bicicleta",
  "bien",
  "bienes",
  "bienestar",
  "bienvenida",
  "bilbao",
  "bill",
  "billete",
  "billetes",
  "billones",
  "blanca",
  "blancas",
  "blanco",
  "blancos",
  "blas",
  "bloque",
  "bloqueo",
  "bloques",
  "boca",
  "boda",
  "bodas",
  "boe",
  "bola",
  "bolas",
  "bolivia",
  "boliviano",
  "bolsa",
  "bolsas",
  "bolsillo",
  "bolsillos",
  "bolso",
  "bomba",
  "bombas",
  "bomberos",
  "bonaerense",
  "bondad",
  "bonita",
  "bonito",
  "bono",
  "bonos",
  "borde",
  "bordes",
  "bordo",
  "borges",
  "borracho",
  "borrar",
  "borrell",
  "bosnia",
  "bosque",
  "bosques",
  "boston",
  "botas",
  "botella",
  "botellas",
  "botones",
  "boxeo",
  "brasil",
  "bravo",
  "brazo",
  "brazos",
  "breve",
  "brevemente",
  "breves",
  "brigada",
  "brillante",
  "brillantes",
  "brillo",
  "brinda",
  "brindar",
  "brisa",
  "broma",
  "bromas",
  "bronce",
  "brown",
  "bruno",
  "bruscamente",
  "bruselas",
  "brutal",
  "bruto",
  "bucaram",
  "buda",
  "budismo",
  "buen",
  "buena",
  "buenas",
  "bueno",
  "buenos",
  "buque",
  "buques",
  "burgos",
  "burla",
  "burocracia",
  "burton",
  "busca",
  "buscaba",
  "buscaban",
  "buscado",
  "buscan",
  "buscando",
  "buscar",
  "bush",
  "caballero",
  "caballeros",
  "caballo",
  "caballos",
  "cabe",
  "cabecera",
  "cabello",
  "cabellos",
  "cabeza",
  "cabezas",
  "cabildo",
  "cabina",
  "cable",
  "cables",
  "cabo",
  "cabrera",
  "cada",
  "cadena",
  "cadenas",
  "cae",
  "caen",
  "caer",
  "caja",
  "cajas",
  "cal",
  "calcio",
  "calcula",
  "calcular",
  "caldera",
  "caldo",
  "calendario",
  "cali",
  "calibre",
  "calidad",
  "caliente",
  "calientes",
  "califica",
  "calificado",
  "calificar",
  "california",
  "calla",
  "callado",
  "calle",
  "calles",
  "calma",
  "calor",
  "calvo",
  "calzada",
  "cama",
  "camacho",
  "camarero",
  "camas",
  "cambia",
  "cambiado",
  "cambian",
  "cambiando",
  "cambiar",
  "cambio",
  "cambios",
  "camilo",
  "camina",
  "caminaba",
  "caminando",
  "caminar",
  "camino",
  "caminos",
  "camiones",
  "camioneta",
  "camisa",
  "camiseta",
  "camp",
  "campamento",
  "campana",
  "campanas",
  "campeonato",
  "campeones",
  "campesina",
  "campesino",
  "campesinos",
  "campo",
  "campos",
  "canadiense",
  "canal",
  "canales",
  "canaria",
  "canarias",
  "canario",
  "cancha",
  "canciller",
  "canciones",
  "candelaria",
  "candidato",
  "candidatos",
  "candidatura",
  "candidaturas",
  "canela",
  "cano",
  "cansada",
  "cansado",
  "cansancio",
  "canta",
  "cantaba",
  "cantabria",
  "cantando",
  "cantante",
  "cantantes",
  "cantar",
  "cantidad",
  "cantidades",
  "canto",
  "cantos",
  "caos",
  "capa",
  "capaces",
  "capacidad",
  "capacidades",
  "capas",
  "capaz",
  "capilla",
  "capital",
  "capitales",
  "capitalismo",
  "capitalista",
  "capricho",
  "captar",
  "captura",
  "cara",
  "caracas",
  "caracteres",
  "caracteriza",
  "caracterizado",
  "caracterizan",
  "carajo",
  "caras",
  "carbono",
  "carcajada",
  "carcajadas",
  "cardenal",
  "carece",
  "carecen",
  "carencia",
  "carencias",
  "caretas",
  "carga",
  "cargada",
  "cargado",
  "cargar",
  "cargas",
  "cargo",
  "cargos",
  "caribe",
  "caridad",
  "carla",
  "carles",
  "carlitos",
  "carlos",
  "carlota",
  "carme",
  "carmelo",
  "carmen",
  "carnaval",
  "carne",
  "carnes",
  "caro",
  "carolina",
  "carpeta",
  "carrasco",
  "carrera",
  "carreras",
  "carretera",
  "carreteras",
  "carrillo",
  "carro",
  "carros",
  "carta",
  "cartagena",
  "cartas",
  "cartel",
  "carteles",
  "carter",
  "cartera",
  "casa",
  "casada",
  "casado",
  "casarse",
  "casas",
  "casco",
  "cascos",
  "casi",
  "casino",
  "caso",
  "casos",
  "castellana",
  "castellano",
  "castellanos",
  "castigo",
  "castilla",
  "castillo",
  "castro",
  "casual",
  "casualidad",
  "catalana",
  "catalanes",
  "catalina",
  "catalunya",
  "catedral",
  "catorce",
  "cauce",
  "caudal",
  "caudillo",
  "causa",
  "causado",
  "causar",
  "causas",
  "cautela",
  "cavallo",
  "cayendo",
  "cayeron",
  "caza",
  "cazador",
  "cazuela",
  "cebolla",
  "cecilia",
  "ceder",
  "cejas",
  "celda",
  "celebra",
  "celebrada",
  "celebrado",
  "celebran",
  "celebrar",
  "celeste",
  "celia",
  "celo",
  "celos",
  "celta",
  "celular",
  "celulares",
  "cementerio",
  "cemento",
  "cena",
  "cenar",
  "cenizas",
  "censo",
  "censura",
  "centavos",
  "centenar",
  "centenares",
  "centenario",
  "centra",
  "central",
  "centrales",
  "centro",
  "centros",
  "cera",
  "cerca",
  "cercana",
  "cercanas",
  "cercano",
  "cercanos",
  "cerco",
  "cerdo",
  "cereales",
  "cerebral",
  "cerebro",
  "ceremonia",
  "ceremonias",
  "cero",
  "cerrada",
  "cerradas",
  "cerrado",
  "cerrados",
  "cerrar",
  "cerro",
  "certamen",
  "certeza",
  "certificado",
  "cervantes",
  "cerveza",
  "cesar",
  "cese",
  "cesid",
  "chamorro",
  "chaqueta",
  "charla",
  "charles",
  "chaves",
  "che",
  "chiapas",
  "chica",
  "chicago",
  "chicas",
  "chico",
  "chicos",
  "chile",
  "chilena",
  "chileno",
  "chilenos",
  "chimenea",
  "china",
  "chino",
  "chinos",
  "chirac",
  "chocolate",
  "chofer",
  "choque",
  "chorro",
  "cia",
  "ciclismo",
  "ciclista",
  "ciclo",
  "ciclos",
  "ciega",
  "ciego",
  "ciegos",
  "cielo",
  "cielos",
  "cien",
  "ciencia",
  "ciencias",
  "ciento",
  "cientos",
  "cierra",
  "cierre",
  "cierta",
  "ciertamente",
  "ciertas",
  "cierto",
  "ciertos",
  "cifra",
  "cifras",
  "cigarrillo",
  "cigarrillos",
  "cima",
  "cinco",
  "cincuenta",
  "cine",
  "cineasta",
  "cinta",
  "cintas",
  "cintura",
  "circo",
  "circuito",
  "circuitos",
  "circular",
  "circunstancia",
  "circunstancias",
  "cirujano",
  "cita",
  "citada",
  "citadas",
  "citado",
  "citados",
  "citar",
  "citas",
  "ciudad",
  "ciudadana",
  "ciudadano",
  "ciudadanos",
  "ciudades",
  "civil",
  "civiles",
  "clara",
  "claramente",
  "claras",
  "claridad",
  "claro",
  "claros",
  "clase",
  "clases",
  "claudia",
  "claudio",
  "claustro",
  "clausura",
  "clave",
  "claves",
  "clemente",
  "clic",
  "cliente",
  "clientela",
  "clientes",
  "clima",
  "clinton",
  "club",
  "clubes",
  "cobertura",
  "cobra",
  "cobran",
  "cobrar",
  "cobre",
  "cobro",
  "coca",
  "cocer",
  "cochabamba",
  "coche",
  "coches",
  "cocido",
  "cocina",
  "cocinar",
  "coco",
  "codo",
  "coge",
  "coger",
  "cogido",
  "coherencia",
  "coherente",
  "coincide",
  "coinciden",
  "coincidencia",
  "coincidiendo",
  "coincidieron",
  "coincidir",
  "col",
  "cola",
  "colaborador",
  "colaboradores",
  "colaborar",
  "colecciones",
  "colectiva",
  "colectivo",
  "colectivos",
  "colega",
  "colegas",
  "colegio",
  "colegios",
  "colesterol",
  "colina",
  "colmo",
  "coloca",
  "colocado",
  "colocan",
  "colocar",
  "colombia",
  "colombiana",
  "colombiano",
  "colombianos",
  "colonia",
  "colonial",
  "colonias",
  "color",
  "colorado",
  "colores",
  "columna",
  "columnas",
  "coma",
  "comandante",
  "comando",
  "comarca",
  "combate",
  "combates",
  "combatir",
  "combinaciones",
  "combustible",
  "combustibles",
  "come",
  "comedia",
  "comedor",
  "comen",
  "comenta",
  "comentado",
  "comentar",
  "comentario",
  "comentarios",
  "comenzaba",
  "comenzado",
  "comenzando",
  "comenzar",
  "comenzaron",
  "comer",
  "comercial",
  "comerciales",
  "comerciante",
  "comerciantes",
  "comercio",
  "comercios",
  "cometer",
  "cometido",
  "cometidos",
  "comicios",
  "comida",
  "comidas",
  "comido",
  "comiendo",
  "comienza",
  "comienzan",
  "comienzo",
  "comienzos",
  "comisario",
  "comisiones",
  "como",
  "comodidad",
  "compadre",
  "comparar",
  "comparecencia",
  "comparte",
  "comparten",
  "compartida",
  "compartido",
  "compartir",
  "compatriotas",
  "compensar",
  "competencia",
  "competencias",
  "competente",
  "competir",
  "competitividad",
  "compleja",
  "complejas",
  "complejidad",
  "complejo",
  "complejos",
  "complementarias",
  "complemento",
  "completa",
  "completamente",
  "completar",
  "completo",
  "complicaciones",
  "complicada",
  "complicado",
  "complicidad",
  "complutense",
  "compone",
  "componen",
  "componente",
  "componentes",
  "comporta",
  "comportamiento",
  "comportamientos",
  "composiciones",
  "compositor",
  "compositores",
  "compostela",
  "compra",
  "comprado",
  "comprador",
  "compradores",
  "comprar",
  "compras",
  "comprende",
  "comprender",
  "comprendido",
  "comprendo",
  "comprensible",
  "comprobado",
  "comprobar",
  "comprometido",
  "compromiso",
  "compromisos",
  "compuesta",
  "compuesto",
  "compuestos",
  "computadora",
  "computadoras",
  "comuna",
  "comunes",
  "comunica",
  "comunicaciones",
  "comunicado",
  "comunicar",
  "comunicarse",
  "comunidad",
  "comunidades",
  "comunismo",
  "comunista",
  "comunistas",
  "comunitaria",
  "comunitario",
  "comunitarios",
  "concebir",
  "concede",
  "conceder",
  "concedido",
  "concejal",
  "concejales",
  "concentra",
  "concentraciones",
  "concentrado",
  "concepciones",
  "concepto",
  "conceptos",
  "conceptual",
  "concesiones",
  "concha",
  "conciencia",
  "concierto",
  "conciertos",
  "concluido",
  "concluir",
  "conclusiones",
  "concluye",
  "concreta",
  "concretamente",
  "concretar",
  "concretas",
  "concreto",
  "concretos",
  "concurrencia",
  "concurso",
  "concursos",
  "condado",
  "conde",
  "condena",
  "condenado",
  "condenados",
  "condiciones",
  "conduce",
  "conducen",
  "conducido",
  "conducir",
  "conducta",
  "conductas",
  "conductor",
  "conductores",
  "condujo",
  "conejo",
  "conexiones",
  "conferencia",
  "conferencias",
  "confianza",
  "confiar",
  "confiesa",
  "confirma",
  "confirmado",
  "confirmar",
  "conflicto",
  "conflictos",
  "conforman",
  "conforme",
  "conformidad",
  "confundir",
  "confuso",
  "congreso",
  "congresos",
  "conjunta",
  "conjuntamente",
  "conjunto",
  "conjuntos",
  "conlleva",
  "conmigo",
  "conoce",
  "conocemos",
  "conocen",
  "conocer",
  "conocerse",
  "conoces",
  "conocida",
  "conocidas",
  "conocido",
  "conocidos",
  "conocimiento",
  "conocimientos",
  "conozca",
  "conozco",
  "conquista",
  "conquistar",
  "consciente",
  "conscientes",
  "consecuencia",
  "consecuencias",
  "consecuente",
  "conseguido",
  "conseguir",
  "consejero",
  "consejeros",
  "consejo",
  "consejos",
  "consenso",
  "consentimiento",
  "conserva",
  "conservador",
  "conservadora",
  "conservadores",
  "conservan",
  "conservar",
  "considera",
  "consideraba",
  "considerable",
  "considerablemente",
  "consideraciones",
  "considerada",
  "consideradas",
  "considerado",
  "considerados",
  "consideramos",
  "consideran",
  "considerando",
  "considerar",
  "considerarse",
  "considere",
  "considero",
  "consigna",
  "consigo",
  "consigue",
  "consiguen",
  "consiguiente",
  "consiguieron",
  "consiste",
  "consistencia",
  "consistente",
  "consolidar",
  "consorcio",
  "consta",
  "constancia",
  "constante",
  "constantemente",
  "constantes",
  "constatar",
  "constitucional",
  "constitucionales",
  "constituida",
  "constituido",
  "constituir",
  "constituye",
  "constituyen",
  "constituyente",
  "construcciones",
  "construida",
  "construido",
  "construir",
  "construye",
  "consuelo",
  "consulta",
  "consultado",
  "consultar",
  "consultas",
  "consume",
  "consumidor",
  "consumidores",
  "consumir",
  "consumo",
  "contaba",
  "contaban",
  "contabilidad",
  "contacto",
  "contactos",
  "contado",
  "contando",
  "contar",
  "contempla",
  "contemplaba",
  "contemplar",
  "contener",
  "contenida",
  "contenido",
  "contenidos",
  "contenta",
  "contento",
  "contesta",
  "contestar",
  "contexto",
  "contienda",
  "contiene",
  "contienen",
  "contigo",
  "continental",
  "continente",
  "continua",
  "continuaba",
  "continuado",
  "continuamente",
  "continuar",
  "continuidad",
  "continuo",
  "contra",
  "contrabando",
  "contradicciones",
  "contraria",
  "contrario",
  "contrarios",
  "contraste",
  "contratado",
  "contratar",
  "contrato",
  "contratos",
  "contreras",
  "contribuido",
  "contribuir",
  "contribuye",
  "contribuyen",
  "contribuyentes",
  "control",
  "controla",
  "controlada",
  "controlado",
  "controlar",
  "controles",
  "contundente",
  "convencer",
  "convencido",
  "convencidos",
  "convencimiento",
  "convencional",
  "convencionales",
  "conveniencia",
  "conveniente",
  "convenio",
  "convenios",
  "convento",
  "convergencia",
  "conversaciones",
  "conversar",
  "convertida",
  "convertido",
  "convertir",
  "convertirse",
  "convicciones",
  "conviene",
  "convierta",
  "convierte",
  "convierten",
  "convirtiendo",
  "convirtieron",
  "convivencia",
  "convocada",
  "convocado",
  "convocar",
  "convocatoria",
  "cooperativa",
  "cooperativas",
  "coordinador",
  "coordinadora",
  "copa",
  "copas",
  "copia",
  "copias",
  "coraje",
  "coral",
  "corazones",
  "corbata",
  "cordero",
  "cordillera",
  "corea",
  "coro",
  "corona",
  "coronel",
  "corporaciones",
  "corporal",
  "corral",
  "corre",
  "correa",
  "correcta",
  "correctamente",
  "correcto",
  "corredor",
  "corredores",
  "corregir",
  "corren",
  "correo",
  "correos",
  "correr",
  "corresponde",
  "corresponden",
  "correspondencia",
  "correspondiente",
  "correspondientes",
  "corresponsal",
  "corrida",
  "corridas",
  "corrido",
  "corriendo",
  "corriente",
  "corrientes",
  "corta",
  "cortado",
  "cortar",
  "cortas",
  "corte",
  "cortes",
  "corteza",
  "cortina",
  "cortinas",
  "corto",
  "cortos",
  "cosa",
  "cosas",
  "cosecha",
  "costa",
  "costado",
  "costas",
  "coste",
  "costes",
  "costo",
  "costos",
  "costumbre",
  "costumbres",
  "cotidiana",
  "cotidiano",
  "coyuntura",
  "crea",
  "creada",
  "creado",
  "creador",
  "creadora",
  "creadores",
  "crean",
  "creando",
  "crear",
  "crearon",
  "creativa",
  "creatividad",
  "creativo",
  "crece",
  "crecen",
  "crecer",
  "crecido",
  "creciendo",
  "creciente",
  "crecimiento",
  "credibilidad",
  "cree",
  "creemos",
  "creen",
  "creencia",
  "creencias",
  "creer",
  "crees",
  "crema",
  "creo",
  "crespo",
  "creyendo",
  "criada",
  "criado",
  "criatura",
  "criaturas",
  "crimen",
  "criminal",
  "criminales",
  "crisis",
  "cristal",
  "cristales",
  "cristian",
  "cristiana",
  "cristianismo",
  "cristiano",
  "cristianos",
  "cristina",
  "cristo",
  "criterio",
  "criterios",
  "critica",
  "cruce",
  "crucero",
  "cruces",
  "crucial",
  "crudo",
  "cruel",
  "crueldad",
  "cruyff",
  "cruz",
  "cruza",
  "cruzada",
  "cruzado",
  "cruzar",
  "cuaderno",
  "cuadra",
  "cuadrado",
  "cuadrados",
  "cuadro",
  "cuadros",
  "cual",
  "cuales",
  "cualidad",
  "cualidades",
  "cualquier",
  "cualquiera",
  "cuando",
  "cuantas",
  "cuanto",
  "cuantos",
  "cuarenta",
  "cuarta",
  "cuartel",
  "cuarto",
  "cuartos",
  "cuatro",
  "cuba",
  "cubana",
  "cubano",
  "cubanos",
  "cubierta",
  "cubiertas",
  "cubierto",
  "cubiertos",
  "cubre",
  "cubren",
  "cubrir",
  "cucharada",
  "cucharadas",
  "cucharadita",
  "cuchillo",
  "cuello",
  "cuenca",
  "cuenta",
  "cuentan",
  "cuentas",
  "cuente",
  "cuento",
  "cuentos",
  "cuerda",
  "cuerdas",
  "cuero",
  "cuerpo",
  "cuerpos",
  "cuesta",
  "cuestiones",
  "cueva",
  "cuevas",
  "cuidado",
  "cuidados",
  "cuidadosamente",
  "cuidar",
  "culo",
  "culpa",
  "culpable",
  "culpables",
  "cultivo",
  "cultivos",
  "culto",
  "cultura",
  "cultural",
  "culturales",
  "culturas",
  "cumbre",
  "cumpla",
  "cumplan",
  "cumple",
  "cumplen",
  "cumplido",
  "cumpliendo",
  "cumplimiento",
  "cumplir",
  "cuna",
  "cuota",
  "cuotas",
  "cura",
  "curar",
  "curas",
  "curiosa",
  "curiosamente",
  "curiosidad",
  "curioso",
  "curiosos",
  "curso",
  "cursos",
  "curva",
  "curvas",
  "custodia",
  "cuya",
  "cuyas",
  "cuyo",
  "cuyos",
  "daba",
  "daban",
  "dada",
  "dadas",
  "dado",
  "dados",
  "dama",
  "damas",
  "dame",
  "damos",
  "dando",
  "daniel",
  "daniela",
  "danza",
  "darle",
  "darles",
  "darme",
  "darnos",
  "darse",
  "darwin",
  "data",
  "dato",
  "datos",
  "david",
  "davis",
  "deba",
  "debajo",
  "debate",
  "debates",
  "debe",
  "debemos",
  "deben",
  "deber",
  "deberes",
  "debes",
  "debida",
  "debidamente",
  "debido",
  "debiera",
  "debieron",
  "debilidad",
  "debo",
  "debut",
  "decadencia",
  "decenas",
  "decida",
  "decide",
  "deciden",
  "decidida",
  "decidido",
  "decidieron",
  "decidir",
  "decimos",
  "decir",
  "decirle",
  "decirlo",
  "decirme",
  "decirse",
  "decirte",
  "decisiones",
  "decisiva",
  "decisivo",
  "declara",
  "declaraciones",
  "declarado",
  "declarar",
  "decreto",
  "decretos",
  "dedica",
  "dedicada",
  "dedicadas",
  "dedicado",
  "dedicados",
  "dedican",
  "dedicar",
  "dedicarse",
  "dedo",
  "dedos",
  "defecto",
  "defectos",
  "defender",
  "defenderse",
  "defendido",
  "defensa",
  "defensas",
  "defensiva",
  "defensor",
  "defensores",
  "deficiencia",
  "deficiencias",
  "deficiente",
  "defiende",
  "defienden",
  "define",
  "definen",
  "definiciones",
  "definida",
  "definido",
  "definidos",
  "definir",
  "definitiva",
  "definitivamente",
  "definitivo",
  "deja",
  "dejaba",
  "dejaban",
  "dejado",
  "dejamos",
  "dejan",
  "dejando",
  "dejar",
  "dejara",
  "dejarlo",
  "dejaron",
  "dejarse",
  "deje",
  "dejen",
  "dejo",
  "delante",
  "delantero",
  "delegaciones",
  "delegado",
  "delegados",
  "delgada",
  "delgado",
  "delia",
  "delicada",
  "delicado",
  "delincuencia",
  "delincuentes",
  "delirio",
  "delito",
  "delitos",
  "demanda",
  "demandas",
  "demasiada",
  "demasiadas",
  "demasiado",
  "demasiados",
  "democracia",
  "demonio",
  "demonios",
  "demora",
  "demostrado",
  "demostrar",
  "demuestra",
  "demuestran",
  "denomina",
  "denominada",
  "denominado",
  "densidad",
  "dentro",
  "denuncia",
  "denunciado",
  "denunciar",
  "denuncias",
  "departamento",
  "departamentos",
  "depende",
  "dependen",
  "dependencia",
  "dependencias",
  "depender",
  "dependiendo",
  "dependiente",
  "dependientes",
  "deporte",
  "deportes",
  "deportistas",
  "deportiva",
  "deportivas",
  "deportivo",
  "deportivos",
  "depresiones",
  "depresivo",
  "derecha",
  "derecho",
  "derechos",
  "deriva",
  "derivadas",
  "derivado",
  "derivados",
  "derrota",
  "derrotado",
  "derrotar",
  "desacuerdo",
  "desagradable",
  "desaparece",
  "desaparecen",
  "desaparecer",
  "desaparecido",
  "desaparecidos",
  "desarrolla",
  "desarrollada",
  "desarrolladas",
  "desarrollado",
  "desarrollados",
  "desarrollan",
  "desarrollando",
  "desarrollar",
  "desarrollarse",
  "desarrollo",
  "desastre",
  "desayuno",
  "descansar",
  "descanso",
  "descarga",
  "descarta",
  "descender",
  "descendientes",
  "descenso",
  "desciende",
  "desconcierto",
  "desconfianza",
  "desconoce",
  "desconocida",
  "desconocido",
  "desconocidos",
  "desconocimiento",
  "descontento",
  "describe",
  "describir",
  "descrito",
  "descubierto",
  "descubre",
  "descubrieron",
  "descubrimiento",
  "descubrimientos",
  "descubrir",
  "desde",
  "desea",
  "deseaba",
  "deseable",
  "deseado",
  "desean",
  "desear",
  "desechos",
  "desempleo",
  "desenlace",
  "deseo",
  "deseos",
  "desequilibrio",
  "desesperada",
  "desesperado",
  "desfile",
  "desgracia",
  "desgraciadamente",
  "desierto",
  "designado",
  "designar",
  "desigual",
  "desigualdad",
  "desnuda",
  "desnudo",
  "desnudos",
  "desorden",
  "despacho",
  "despacio",
  "despedida",
  "despedirse",
  "despejado",
  "despertado",
  "despertar",
  "despido",
  "despierta",
  "desplazamiento",
  "desplazamientos",
  "despliegue",
  "desprecio",
  "desprende",
  "destaca",
  "destacado",
  "destacados",
  "destacan",
  "destacar",
  "destinada",
  "destinadas",
  "destinado",
  "destinados",
  "destino",
  "destinos",
  "destruido",
  "destruir",
  "detalle",
  "detalles",
  "detectado",
  "detectar",
  "detener",
  "detenerse",
  "detenido",
  "detenidos",
  "deterioro",
  "determina",
  "determinada",
  "determinadas",
  "determinado",
  "determinados",
  "determinan",
  "determinante",
  "determinar",
  "detiene",
  "detuvo",
  "deuda",
  "deudas",
  "devolver",
  "diabetes",
  "diablo",
  "diana",
  "diaria",
  "diariamente",
  "diarias",
  "diario",
  "diarios",
  "dibujo",
  "dibujos",
  "diccionario",
  "dice",
  "dicen",
  "dices",
  "dicha",
  "dichas",
  "dicho",
  "dichos",
  "diciembre",
  "diciendo",
  "dictador",
  "dictadura",
  "dictamen",
  "dieciocho",
  "diecisiete",
  "diego",
  "diente",
  "dientes",
  "diera",
  "dieron",
  "dieta",
  "dietas",
  "diez",
  "diferencia",
  "diferencial",
  "diferencias",
  "diferente",
  "diferentes",
  "dificultad",
  "dificultades",
  "difundir",
  "difunto",
  "diga",
  "digamos",
  "digan",
  "digas",
  "digital",
  "digna",
  "dignidad",
  "digno",
  "digo",
  "dije",
  "dijera",
  "dijeron",
  "dijiste",
  "dijo",
  "diligencias",
  "dime",
  "dimensiones",
  "dina",
  "dinamarca",
  "dinamismo",
  "dinero",
  "dionisio",
  "dios",
  "diosa",
  "dioses",
  "diputado",
  "diputados",
  "direcciones",
  "directa",
  "directamente",
  "directas",
  "directiva",
  "directivo",
  "directivos",
  "directo",
  "director",
  "directora",
  "directores",
  "directorio",
  "directos",
  "dirige",
  "dirigen",
  "dirigente",
  "dirigentes",
  "dirigida",
  "dirigidas",
  "dirigido",
  "dirigidos",
  "dirigir",
  "dirigirse",
  "disciplina",
  "disciplinas",
  "disco",
  "discos",
  "discrepancias",
  "discreta",
  "discreto",
  "discurso",
  "discursos",
  "discusiones",
  "discutir",
  "disfrutar",
  "disgusto",
  "disimular",
  "disminuido",
  "disminuir",
  "disminuye",
  "disparar",
  "disparo",
  "disparos",
  "dispone",
  "disponen",
  "disponer",
  "disponibilidad",
  "disponible",
  "disponibles",
  "disposiciones",
  "dispositivo",
  "dispositivos",
  "dispuesta",
  "dispuestas",
  "dispuesto",
  "dispuestos",
  "dispuso",
  "disputa",
  "distancia",
  "distancias",
  "distante",
  "distingue",
  "distinguir",
  "distinta",
  "distintas",
  "distinto",
  "distintos",
  "distrito",
  "diversa",
  "diversas",
  "diversidad",
  "diversos",
  "divertido",
  "divide",
  "dividida",
  "dividido",
  "divina",
  "divino",
  "divisa",
  "divisas",
  "divisiones",
  "divorcio",
  "doble",
  "dobles",
  "doce",
  "docena",
  "docente",
  "docentes",
  "doctor",
  "doctora",
  "doctores",
  "doctrina",
  "documental",
  "documento",
  "documentos",
  "dolor",
  "dolores",
  "dolorosa",
  "doloroso",
  "dolors",
  "domicilio",
  "domina",
  "dominado",
  "dominante",
  "dominantes",
  "dominar",
  "domingo",
  "domingos",
  "dominicana",
  "dominicano",
  "dominio",
  "don",
  "donde",
  "dorada",
  "dorado",
  "dormida",
  "dormido",
  "dormir",
  "dormitorio",
  "dos",
  "doscientos",
  "dosis",
  "dotado",
  "drama",
  "droga",
  "drogas",
  "duda",
  "dudar",
  "dudas",
  "duele",
  "duelo",
  "duerme",
  "duhalde",
  "dulce",
  "dulces",
  "duque",
  "dura",
  "durante",
  "durar",
  "duras",
  "dureza",
  "durmiendo",
  "duro",
  "duros",
  "ebro",
  "echa",
  "echado",
  "echar",
  "eco",
  "economista",
  "economistas",
  "ecuador",
  "edad",
  "edades",
  "ediciones",
  "edificio",
  "edificios",
  "editor",
  "editores",
  "editorial",
  "editoriales",
  "edmundo",
  "eduardo",
  "educativa",
  "educativas",
  "educativo",
  "educativos",
  "eeuu",
  "efe",
  "efectiva",
  "efectivamente",
  "efectividad",
  "efectivo",
  "efectivos",
  "efecto",
  "efectos",
  "efectuado",
  "efectuar",
  "eficaces",
  "eficacia",
  "eficaz",
  "eficiencia",
  "eficiente",
  "egipto",
  "einstein",
  "eje",
  "ejecutar",
  "ejecutiva",
  "ejecutivo",
  "ejecutivos",
  "ejemplar",
  "ejemplares",
  "ejemplo",
  "ejemplos",
  "ejerce",
  "ejercen",
  "ejercer",
  "ejercicio",
  "ejercicios",
  "ejes",
  "elaborado",
  "elaborados",
  "elaborar",
  "elecciones",
  "electo",
  "electorado",
  "electoral",
  "electorales",
  "electores",
  "electricidad",
  "electrones",
  "elegancia",
  "elegante",
  "elegida",
  "elegido",
  "elegidos",
  "elegir",
  "elemental",
  "elementales",
  "elemento",
  "elementos",
  "elena",
  "eleva",
  "elevada",
  "elevadas",
  "elevado",
  "elevados",
  "elevar",
  "elige",
  "elimina",
  "eliminar",
  "eliminatoria",
  "ella",
  "ellas",
  "ello",
  "ellos",
  "eloy",
  "elvira",
  "embajada",
  "embajador",
  "embarazada",
  "embarazo",
  "embarcaciones",
  "embargo",
  "emergencia",
  "emilia",
  "emilio",
  "emisiones",
  "emisor",
  "emisora",
  "emisoras",
  "emite",
  "emitido",
  "emitir",
  "emocional",
  "emocionales",
  "emociones",
  "empate",
  "emperador",
  "empezaba",
  "empezado",
  "empezamos",
  "empezando",
  "empezar",
  "empezaron",
  "empieza",
  "empiezan",
  "emplea",
  "empleada",
  "empleado",
  "empleados",
  "emplean",
  "emplear",
  "empleo",
  "empleos",
  "emprender",
  "empresa",
  "empresarial",
  "empresariales",
  "empresario",
  "empresarios",
  "empresas",
  "enamorado",
  "encabeza",
  "encabezada",
  "encanta",
  "encanto",
  "encarga",
  "encargada",
  "encargado",
  "encargados",
  "encargo",
  "encender",
  "encendido",
  "encerrado",
  "enciende",
  "encierra",
  "encierro",
  "encima",
  "encontraba",
  "encontraban",
  "encontrado",
  "encontramos",
  "encontrar",
  "encontraron",
  "encontrarse",
  "encuentra",
  "encuentran",
  "encuentre",
  "encuentren",
  "encuentro",
  "encuentros",
  "encuesta",
  "encuestas",
  "ende",
  "eneko",
  "enemigo",
  "enemigos",
  "enero",
  "enferma",
  "enfermedad",
  "enfermedades",
  "enfermera",
  "enfermo",
  "enfermos",
  "enfoque",
  "enfrenta",
  "enfrentamiento",
  "enfrentamientos",
  "enfrentan",
  "enfrentar",
  "enfrentarse",
  "enfrente",
  "enlace",
  "enmienda",
  "enmiendas",
  "enorme",
  "enormemente",
  "enormes",
  "enrique",
  "ensalada",
  "ensayo",
  "ensayos",
  "enseguida",
  "ente",
  "entendemos",
  "entender",
  "entenderse",
  "entendido",
  "entendimiento",
  "entera",
  "enterado",
  "enteramente",
  "enterarse",
  "enteras",
  "entero",
  "enteros",
  "entidad",
  "entidades",
  "entiende",
  "entienden",
  "entiendes",
  "entiendo",
  "entierro",
  "entonces",
  "entorno",
  "entra",
  "entraba",
  "entrada",
  "entradas",
  "entrado",
  "entramos",
  "entran",
  "entrando",
  "entrar",
  "entraron",
  "entre",
  "entrega",
  "entregado",
  "entregar",
  "entrenador",
  "entrenamiento",
  "entrenamientos",
  "entretanto",
  "entretenimiento",
  "entrevista",
  "entrevistado",
  "entrevistas",
  "entusiasmo",
  "envejecimiento",
  "envergadura",
  "enviada",
  "enviado",
  "enviados",
  "enviar",
  "envidia",
  "envuelto",
  "enzimas",
  "epidemia",
  "episcopal",
  "episodio",
  "episodios",
  "equilibrio",
  "equipamiento",
  "equipo",
  "equipos",
  "equivale",
  "equivalente",
  "equivalentes",
  "equivocado",
  "era",
  "eran",
  "eras",
  "eres",
  "eric",
  "ernesto",
  "error",
  "errores",
  "esas",
  "escala",
  "escalada",
  "escalas",
  "escalera",
  "escaleras",
  "escapa",
  "escapar",
  "escape",
  "escasa",
  "escasas",
  "escasez",
  "escaso",
  "escasos",
  "escena",
  "escenario",
  "escenarios",
  "escenas",
  "escepticismo",
  "esclavitud",
  "esclavo",
  "esclavos",
  "escobar",
  "escoger",
  "escogido",
  "escolar",
  "escolares",
  "escolta",
  "esconde",
  "escondido",
  "escorial",
  "escribe",
  "escribiendo",
  "escribir",
  "escribo",
  "escrita",
  "escritas",
  "escrito",
  "escritor",
  "escritora",
  "escritores",
  "escritorio",
  "escritos",
  "escritura",
  "escucha",
  "escuchaba",
  "escuchado",
  "escuchando",
  "escuchar",
  "escudo",
  "escuela",
  "escuelas",
  "escultor",
  "escultura",
  "esculturas",
  "esencia",
  "esencial",
  "esenciales",
  "esencialmente",
  "esfera",
  "esferas",
  "esfuerzo",
  "esfuerzos",
  "esos",
  "espacial",
  "espaciales",
  "espacio",
  "espacios",
  "espada",
  "espalda",
  "espaldas",
  "especial",
  "especiales",
  "especialidad",
  "especialidades",
  "especialista",
  "especialistas",
  "especializada",
  "especializadas",
  "especializado",
  "especializados",
  "especialmente",
  "especie",
  "especies",
  "espectacular",
  "espectaculares",
  "espectador",
  "espectadores",
  "espectro",
  "espejo",
  "espejos",
  "espera",
  "esperaba",
  "esperaban",
  "esperado",
  "esperamos",
  "esperan",
  "esperando",
  "esperanza",
  "esperanzas",
  "esperar",
  "espero",
  "espesa",
  "espinosa",
  "espiritual",
  "espirituales",
  "esplendor",
  "esposa",
  "esposas",
  "esposo",
  "espuma",
  "esqueleto",
  "esquema",
  "esquemas",
  "esquina",
  "esta",
  "estaba",
  "estaban",
  "estabas",
  "estabilidad",
  "estable",
  "establece",
  "establecen",
  "establecer",
  "establecida",
  "establecidas",
  "establecido",
  "establecidos",
  "establecimiento",
  "establecimientos",
  "estables",
  "estaciones",
  "estadio",
  "estado",
  "estados",
  "estadounidense",
  "estadounidenses",
  "estallar",
  "estallido",
  "estamos",
  "estampa",
  "estancia",
  "estando",
  "estar",
  "estas",
  "estatal",
  "estatales",
  "estatua",
  "estatura",
  "estatuto",
  "estatutos",
  "este",
  "esteban",
  "estela",
  "esther",
  "estilo",
  "estilos",
  "estima",
  "estimaciones",
  "estimado",
  "estimular",
  "esto",
  "estos",
  "estoy",
  "estrategia",
  "estrategias",
  "estratos",
  "estrecha",
  "estrechamente",
  "estrecho",
  "estrella",
  "estrellas",
  "estreno",
  "estricta",
  "estrictamente",
  "estricto",
  "estructura",
  "estructural",
  "estructurales",
  "estructuras",
  "estudia",
  "estudiado",
  "estudian",
  "estudiando",
  "estudiante",
  "estudiantes",
  "estudiantil",
  "estudiar",
  "estudio",
  "estudios",
  "estuve",
  "estuviera",
  "estuvieran",
  "estuvieron",
  "estuviese",
  "estuvimos",
  "estuvo",
  "eta",
  "etapa",
  "etapas",
  "etarras",
  "etc",
  "eterna",
  "eternidad",
  "eterno",
  "etiqueta",
  "euforia",
  "eugenia",
  "eugenio",
  "euro",
  "europa",
  "europea",
  "europeas",
  "europeo",
  "europeos",
  "euros",
  "euskadi",
  "eva",
  "evaluar",
  "evento",
  "eventos",
  "eventual",
  "evidencia",
  "evidencias",
  "evidente",
  "evidentemente",
  "evidentes",
  "evita",
  "evitando",
  "evitar",
  "exacta",
  "exactamente",
  "exactitud",
  "exacto",
  "examen",
  "examinar",
  "excelencia",
  "excelente",
  "excelentes",
  "excepcional",
  "excepcionales",
  "excepciones",
  "excepto",
  "excesiva",
  "excesivamente",
  "excesivo",
  "exceso",
  "excesos",
  "exclusiva",
  "exclusivamente",
  "exclusivo",
  "excusa",
  "exige",
  "exigen",
  "exigencia",
  "exigencias",
  "exigente",
  "exigir",
  "exilio",
  "exista",
  "existan",
  "existe",
  "existen",
  "existencia",
  "existente",
  "existentes",
  "existido",
  "existir",
  "expectativa",
  "expectativas",
  "expediente",
  "expedientes",
  "experiencia",
  "experiencias",
  "experimentado",
  "experimental",
  "experimentar",
  "experimento",
  "experimentos",
  "experto",
  "expertos",
  "explica",
  "explicaba",
  "explicaciones",
  "explicado",
  "explican",
  "explicar",
  "explicaron",
  "explorar",
  "explosivos",
  "explotar",
  "expone",
  "exponer",
  "exportaciones",
  "exposiciones",
  "expresa",
  "expresado",
  "expresamente",
  "expresan",
  "expresar",
  "expresiones",
  "expreso",
  "expuestas",
  "expuesto",
  "expuestos",
  "expulsado",
  "expuso",
  "extender",
  "extendido",
  "extensa",
  "extenso",
  "exterior",
  "exteriores",
  "externa",
  "externas",
  "externo",
  "externos",
  "extiende",
  "extra",
  "extraer",
  "extranjera",
  "extranjeras",
  "extranjero",
  "extranjeros",
  "extraordinaria",
  "extraordinariamente",
  "extraordinario",
  "extrema",
  "extremadamente",
  "extremadura",
  "extremidades",
  "extremo",
  "extremos",
  "fabio",
  "fabricante",
  "fabricantes",
  "fabricar",
  "facciones",
  "fachada",
  "facilidad",
  "facilidades",
  "facilita",
  "facilitar",
  "factor",
  "factores",
  "factura",
  "facultad",
  "facultades",
  "faena",
  "falda",
  "falla",
  "fallas",
  "fallecido",
  "fallecimiento",
  "fallo",
  "fallos",
  "falsa",
  "falsas",
  "falsedad",
  "falso",
  "falsos",
  "falta",
  "faltaba",
  "faltaban",
  "faltan",
  "faltar",
  "faltas",
  "fama",
  "familia",
  "familiar",
  "familiares",
  "familias",
  "famosa",
  "famoso",
  "famosos",
  "fantasma",
  "fantasmas",
  "farah",
  "farc",
  "farmacia",
  "fascinante",
  "fascismo",
  "fase",
  "fases",
  "fatal",
  "fatiga",
  "fatima",
  "fauna",
  "favor",
  "favorable",
  "favorables",
  "favorece",
  "favorecer",
  "favorito",
  "favoritos",
  "fax",
  "fea",
  "febrero",
  "fecha",
  "fechas",
  "federal",
  "federales",
  "federico",
  "felices",
  "felicidad",
  "felipe",
  "feliz",
  "femenina",
  "femenino",
  "feo",
  "feria",
  "fernando",
  "feroz",
  "ferrer",
  "ferrocarril",
  "festival",
  "feto",
  "fianza",
  "fibra",
  "fibras",
  "ficha",
  "fidel",
  "fidelidad",
  "fiebre",
  "fiel",
  "fieles",
  "fiesta",
  "fiestas",
  "figueroa",
  "figura",
  "figuran",
  "figuras",
  "fija",
  "fijado",
  "fijar",
  "fijo",
  "fijos",
  "fila",
  "filas",
  "filial",
  "film",
  "filme",
  "filmes",
  "films",
  "filo",
  "fin",
  "fina",
  "final",
  "finales",
  "finalidad",
  "finalizar",
  "finalmente",
  "financiamiento",
  "financiar",
  "financiera",
  "financieras",
  "financiero",
  "financieros",
  "finanzas",
  "finas",
  "finca",
  "fines",
  "fino",
  "firma",
  "firmado",
  "firmar",
  "firmaron",
  "firmas",
  "firme",
  "firmes",
  "firmeza",
  "fiscal",
  "fiscales",
  "flaco",
  "flamenco",
  "flexibilidad",
  "flexible",
  "flor",
  "flora",
  "florentino",
  "flores",
  "florida",
  "flota",
  "fluido",
  "flujo",
  "foco",
  "focos",
  "fomentar",
  "fomento",
  "fondo",
  "fondos",
  "ford",
  "forestal",
  "forma",
  "formaba",
  "formaban",
  "formaciones",
  "formada",
  "formado",
  "formados",
  "formal",
  "formales",
  "formalmente",
  "forman",
  "formando",
  "formar",
  "formaron",
  "formas",
  "formato",
  "formidable",
  "formular",
  "foro",
  "fortalecer",
  "fortalecimiento",
  "fortaleza",
  "fortuna",
  "forzar",
  "foto",
  "fotos",
  "fox",
  "fracasado",
  "fracaso",
  "fraga",
  "fragmento",
  "fragmentos",
  "franca",
  "francamente",
  "france",
  "francesa",
  "francesas",
  "francesc",
  "franceses",
  "francia",
  "francisca",
  "francisco",
  "franco",
  "francos",
  "franja",
  "frank",
  "franquismo",
  "franquista",
  "frase",
  "frases",
  "fraude",
  "fray",
  "frecuencia",
  "frecuente",
  "frecuentemente",
  "frecuentes",
  "frei",
  "frenar",
  "freno",
  "frente",
  "frentes",
  "fresca",
  "fresco",
  "frescos",
  "freud",
  "frialdad",
  "frontal",
  "frontera",
  "fronteras",
  "fruta",
  "frutas",
  "fruto",
  "frutos",
  "fuego",
  "fuente",
  "fuentes",
  "fuera",
  "fueran",
  "fueron",
  "fuerte",
  "fuertemente",
  "fuertes",
  "fuerza",
  "fuerzas",
  "fuese",
  "fuesen",
  "fuga",
  "fugaz",
  "fuimos",
  "fuiste",
  "fujimori",
  "fumar",
  "funciona",
  "funcional",
  "funcionales",
  "funcionamiento",
  "funcionan",
  "funcionar",
  "funcionario",
  "funcionarios",
  "funciones",
  "funda",
  "fundada",
  "fundado",
  "fundador",
  "fundamental",
  "fundamentales",
  "fundamentalmente",
  "fundamento",
  "fundamentos",
  "furia",
  "futbolista",
  "futbolistas",
  "futura",
  "futuras",
  "futuro",
  "futuros",
  "gabinete",
  "gabriel",
  "gafas",
  "gala",
  "galaxias",
  "galicia",
  "galileo",
  "gallega",
  "gallego",
  "gallegos",
  "gallina",
  "gallo",
  "gama",
  "gana",
  "ganaba",
  "ganaderos",
  "ganado",
  "ganador",
  "ganadores",
  "ganan",
  "ganancia",
  "ganancias",
  "ganando",
  "ganar",
  "ganaron",
  "ganas",
  "garantiza",
  "garantizar",
  "garganta",
  "gas",
  "gases",
  "gasolina",
  "gasto",
  "gastos",
  "gato",
  "gatos",
  "gemma",
  "gen",
  "genera",
  "generaciones",
  "generado",
  "general",
  "generales",
  "generalitat",
  "generalizada",
  "generalizado",
  "generalmente",
  "generan",
  "generar",
  "generosa",
  "generosidad",
  "generoso",
  "genes",
  "genial",
  "genio",
  "gente",
  "gentes",
  "george",
  "gerard",
  "gerardo",
  "gerente",
  "gestiones",
  "gesto",
  "gestos",
  "gibraltar",
  "gigante",
  "gigantes",
  "gigantesco",
  "gil",
  "gimnasia",
  "ginebra",
  "giovanni",
  "gira",
  "girar",
  "giro",
  "global",
  "globales",
  "globo",
  "gloria",
  "glucosa",
  "gobernador",
  "gobernadores",
  "gobernante",
  "gobernantes",
  "gobernar",
  "gobierno",
  "gobiernos",
  "gol",
  "goles",
  "golf",
  "golfo",
  "golpe",
  "golpes",
  "goma",
  "gonzalo",
  "gorbachov",
  "gorda",
  "gordo",
  "gorka",
  "gota",
  "gotas",
  "goya",
  "goza",
  "gozar",
  "grabado",
  "grabados",
  "grabar",
  "gracia",
  "gracias",
  "grado",
  "grados",
  "gradual",
  "gramos",
  "gran",
  "granada",
  "grand",
  "grande",
  "grandes",
  "grandeza",
  "granja",
  "grano",
  "granos",
  "grasa",
  "grasas",
  "grasos",
  "gratis",
  "gratuita",
  "grave",
  "gravedad",
  "gravemente",
  "graves",
  "grecia",
  "gregorio",
  "gremio",
  "griega",
  "griego",
  "griegos",
  "gris",
  "grises",
  "grita",
  "gritaba",
  "gritando",
  "gritar",
  "grito",
  "gritos",
  "gruesa",
  "grueso",
  "grupo",
  "grupos",
  "guadalajara",
  "guadalupe",
  "guantes",
  "guapa",
  "guapo",
  "guarda",
  "guardaba",
  "guardan",
  "guardar",
  "guardia",
  "guardias",
  "guatemala",
  "guayaquil",
  "gubernamental",
  "gubernamentales",
  "guerra",
  "guerras",
  "guerrero",
  "guerrilla",
  "guerrillero",
  "guerrilleros",
  "guevara",
  "guillermo",
  "guitarra",
  "gusta",
  "gustaba",
  "gustado",
  "gustan",
  "gustavo",
  "gusto",
  "gustos",
  "habana",
  "haber",
  "haberle",
  "haberlo",
  "haberse",
  "habiba",
  "habido",
  "habiendo",
  "habilidad",
  "habilidades",
  "habitaciones",
  "habitantes",
  "habitual",
  "habituales",
  "habitualmente",
  "habla",
  "hablaba",
  "hablaban",
  "hablado",
  "hablamos",
  "hablan",
  "hablando",
  "hablar",
  "hablaron",
  "hable",
  "hablo",
  "hace",
  "hacemos",
  "hacen",
  "hacer",
  "hacerla",
  "hacerle",
  "hacerlo",
  "hacerme",
  "hacernos",
  "hacerse",
  "haces",
  "hacia",
  "hacienda",
  "haciendo",
  "haga",
  "hagan",
  "hagas",
  "hago",
  "hall",
  "halla",
  "hallaba",
  "hallado",
  "hallan",
  "hallar",
  "hallazgo",
  "hallazgos",
  "hambre",
  "hanan",
  "hans",
  "haremos",
  "harina",
  "harto",
  "hassan",
  "hasta",
  "hay",
  "haya",
  "hayan",
  "hecha",
  "hechas",
  "hecho",
  "hechos",
  "helado",
  "helms",
  "hembra",
  "hembras",
  "hemisferio",
  "hemos",
  "henry",
  "herald",
  "heredero",
  "herencia",
  "herida",
  "heridas",
  "herido",
  "heridos",
  "hermana",
  "hermanas",
  "hermano",
  "hermanos",
  "hermosa",
  "hermosas",
  "hermoso",
  "hernando",
  "herramienta",
  "herramientas",
  "herrera",
  "herrero",
  "hervir",
  "hice",
  "hiciera",
  "hicieran",
  "hicieron",
  "hicimos",
  "hidalgo",
  "hielo",
  "hierba",
  "hierbas",
  "hierro",
  "higiene",
  "hija",
  "hijas",
  "hijo",
  "hijos",
  "hilo",
  "hilos",
  "himno",
  "hispano",
  "historia",
  "historiador",
  "historiadores",
  "historias",
  "hitler",
  "hizo",
  "hogar",
  "hogares",
  "hoja",
  "hojas",
  "hola",
  "holanda",
  "hollywood",
  "hombre",
  "hombres",
  "hombro",
  "hombros",
  "homenaje",
  "homicidio",
  "homo",
  "homosexuales",
  "honda",
  "hondo",
  "honduras",
  "honestidad",
  "hong",
  "hongos",
  "honor",
  "hora",
  "horacio",
  "horario",
  "horarios",
  "horas",
  "horizontal",
  "horizonte",
  "hormonas",
  "horno",
  "hornos",
  "horrible",
  "horror",
  "hortalizas",
  "hortensia",
  "hospital",
  "hospitales",
  "hostil",
  "hotel",
  "hoteles",
  "hoy",
  "hubiera",
  "hubieran",
  "hubiese",
  "hubiesen",
  "hubo",
  "hueco",
  "huele",
  "huelga",
  "huelgas",
  "huella",
  "huellas",
  "huerta",
  "hueso",
  "huesos",
  "huevo",
  "huevos",
  "hugo",
  "huida",
  "huir",
  "humana",
  "humanas",
  "humanidad",
  "humano",
  "humanos",
  "humberto",
  "humedad",
  "humildad",
  "humilde",
  "humo",
  "humor",
  "iago",
  "iba",
  "ibai",
  "iban",
  "ibarra",
  "iberia",
  "ibrahim",
  "ida",
  "idea",
  "ideal",
  "ideales",
  "ideas",
  "identidad",
  "identifica",
  "identificado",
  "identificados",
  "identificar",
  "idioma",
  "idiomas",
  "idiota",
  "idoia",
  "iglesia",
  "iglesias",
  "ignacio",
  "ignora",
  "ignorancia",
  "ignorar",
  "igor",
  "igual",
  "igualdad",
  "iguales",
  "igualmente",
  "iker",
  "ikram",
  "ilegal",
  "ilegales",
  "iluminado",
  "ilusiones",
  "ilustre",
  "imagen",
  "imagina",
  "imaginaba",
  "imaginar",
  "imaginario",
  "imagino",
  "imanol",
  "impaciencia",
  "impacto",
  "impecable",
  "impedir",
  "imperial",
  "imperio",
  "impide",
  "impiden",
  "implacable",
  "implica",
  "implicaciones",
  "implicados",
  "impone",
  "imponer",
  "imponerse",
  "importa",
  "importaba",
  "importaciones",
  "importancia",
  "importante",
  "importantes",
  "importar",
  "importe",
  "imposibilidad",
  "imposible",
  "imposibles",
  "impotencia",
  "imprenta",
  "imprescindible",
  "impresionante",
  "impresiones",
  "impuesta",
  "impuesto",
  "impuestos",
  "impulsar",
  "impulso",
  "impulsos",
  "impunidad",
  "impuso",
  "incapaces",
  "incapacidad",
  "incapaz",
  "incendio",
  "incendios",
  "incertidumbre",
  "incidencia",
  "incidente",
  "incidentes",
  "incipiente",
  "incluida",
  "incluidas",
  "incluido",
  "incluidos",
  "incluir",
  "inclusive",
  "incluso",
  "incluye",
  "incluyen",
  "incluyendo",
  "inconsciente",
  "inconveniente",
  "inconvenientes",
  "incorpora",
  "incorporado",
  "incorporar",
  "incorporarse",
  "incrementa",
  "incrementar",
  "incremento",
  "incumplimiento",
  "independencia",
  "independiente",
  "independientemente",
  "independientes",
  "india",
  "indias",
  "indica",
  "indicaciones",
  "indicado",
  "indicador",
  "indicadores",
  "indican",
  "indicando",
  "indicar",
  "indicaron",
  "indicios",
  "indiferencia",
  "indiferente",
  "indio",
  "indios",
  "indirecta",
  "indirectamente",
  "indiscutible",
  "indispensable",
  "individual",
  "individuales",
  "individuo",
  "individuos",
  "indudable",
  "indudablemente",
  "industria",
  "industrial",
  "industriales",
  "industrias",
  "inercia",
  "inesperada",
  "inesperado",
  "inestabilidad",
  "inevitable",
  "inevitablemente",
  "infancia",
  "infantil",
  "infantiles",
  "infarto",
  "infecciones",
  "inferior",
  "inferiores",
  "infierno",
  "infinita",
  "infinito",
  "influencia",
  "influencias",
  "influir",
  "influye",
  "influyen",
  "informa",
  "informaciones",
  "informado",
  "informal",
  "informar",
  "informaron",
  "informativa",
  "informativo",
  "informativos",
  "informe",
  "informes",
  "infraestructura",
  "infraestructuras",
  "ingeniero",
  "ingenieros",
  "ingenio",
  "ingesta",
  "inglaterra",
  "inglesa",
  "ingleses",
  "ingredientes",
  "ingresar",
  "ingreso",
  "ingresos",
  "inicia",
  "iniciada",
  "iniciado",
  "inicial",
  "iniciales",
  "inicialmente",
  "inician",
  "iniciar",
  "iniciaron",
  "iniciarse",
  "iniciativa",
  "iniciativas",
  "inicio",
  "inicios",
  "injusticia",
  "injusto",
  "inmaculada",
  "inmediaciones",
  "inmediata",
  "inmediatamente",
  "inmediato",
  "inmediatos",
  "inmensa",
  "inmenso",
  "inmigrantes",
  "inminente",
  "inmueble",
  "innovaciones",
  "innumerables",
  "inocencia",
  "inocente",
  "inocentes",
  "inolvidable",
  "inquietante",
  "inquieto",
  "inquietud",
  "inquietudes",
  "insectos",
  "inseguridad",
  "insiste",
  "insistencia",
  "insistir",
  "insomnio",
  "insoportable",
  "inspector",
  "inspectores",
  "inspirado",
  "instalaciones",
  "instalada",
  "instalado",
  "instalar",
  "instancia",
  "instancias",
  "instante",
  "instantes",
  "instinto",
  "institucional",
  "institucionales",
  "instituciones",
  "instituto",
  "institutos",
  "instrucciones",
  "instrumental",
  "instrumento",
  "instrumentos",
  "insuficiencia",
  "insuficiente",
  "insulina",
  "insultos",
  "integra",
  "integrada",
  "integrado",
  "integrados",
  "integral",
  "integran",
  "integrante",
  "integrantes",
  "integrar",
  "integridad",
  "intelectual",
  "intelectuales",
  "inteligencia",
  "inteligente",
  "inteligentes",
  "intenciones",
  "intensa",
  "intensamente",
  "intensidad",
  "intenso",
  "intensos",
  "intenta",
  "intentaba",
  "intentado",
  "intentan",
  "intentando",
  "intentar",
  "intentaron",
  "intento",
  "intentos",
  "intercambio",
  "intercambios",
  "interesa",
  "interesaba",
  "interesada",
  "interesado",
  "interesados",
  "interesan",
  "interesante",
  "interesantes",
  "intereses",
  "interior",
  "interiores",
  "interlocutor",
  "intermedio",
  "interminable",
  "interna",
  "internacional",
  "internacionales",
  "internas",
  "internet",
  "interno",
  "internos",
  "interpreta",
  "interpretaciones",
  "interpretado",
  "interpretar",
  "interrogantes",
  "interrumpe",
  "intervalo",
  "intervalos",
  "intervenciones",
  "intervenir",
  "interviene",
  "intervienen",
  "intervino",
  "intestino",
  "intimidad",
  "introduce",
  "introducido",
  "introducir",
  "introdujo",
  "inventado",
  "inventar",
  "invento",
  "inversa",
  "inversiones",
  "inversionistas",
  "inversores",
  "invertido",
  "invertir",
  "investiga",
  "investigaciones",
  "investigador",
  "investigadores",
  "investigar",
  "invierno",
  "invisible",
  "invita",
  "invitado",
  "invitados",
  "involucrados",
  "ira",
  "irak",
  "irati",
  "iratxe",
  "irene",
  "iria",
  "iris",
  "irlanda",
  "irme",
  "irregular",
  "irregulares",
  "irregularidades",
  "irreversible",
  "irse",
  "isabel",
  "isidro",
  "isla",
  "islam",
  "islas",
  "ismael",
  "israel",
  "italia",
  "italiana",
  "italiano",
  "italianos",
  "itinerario",
  "itziar",
  "iva",
  "izaro",
  "izquierda",
  "izquierdas",
  "izquierdo",
  "jacinto",
  "jackson",
  "jacques",
  "jaime",
  "james",
  "janeiro",
  "japonesa",
  "japoneses",
  "jardines",
  "jaula",
  "jaume",
  "javier",
  "jazz",
  "jean",
  "jefatura",
  "jefe",
  "jefes",
  "jerez",
  "jesucristo",
  "jinete",
  "joan",
  "joaquim",
  "joel",
  "john",
  "johnny",
  "johnson",
  "jones",
  "jordi",
  "jorge",
  "jornada",
  "jornadas",
  "jose",
  "josefa",
  "josefina",
  "josep",
  "joseph",
  "josu",
  "joven",
  "joyas",
  "juan",
  "juana",
  "juanito",
  "jubilados",
  "judicial",
  "judiciales",
  "judit",
  "jueces",
  "juega",
  "juegan",
  "juego",
  "juegos",
  "jueves",
  "juez",
  "jugaba",
  "jugada",
  "jugado",
  "jugador",
  "jugadores",
  "jugando",
  "jugar",
  "jugo",
  "juguetes",
  "juicio",
  "juicios",
  "julen",
  "julia",
  "juliana",
  "julio",
  "june",
  "junio",
  "junta",
  "juntas",
  "junto",
  "juntos",
  "jurado",
  "juro",
  "justa",
  "justamente",
  "justicia",
  "justifica",
  "justificar",
  "justo",
  "juvenil",
  "juveniles",
  "juventud",
  "juzgado",
  "juzgados",
  "juzgar",
  "kant",
  "karim",
  "karima",
  "kennedy",
  "khadija",
  "kilo",
  "kilos",
  "kohl",
  "kong",
  "laberinto",
  "labios",
  "labor",
  "laboral",
  "laborales",
  "laboratorio",
  "laboratorios",
  "labores",
  "lado",
  "lados",
  "ladrillos",
  "ladrones",
  "lago",
  "lagos",
  "laguna",
  "lagunas",
  "laia",
  "laila",
  "lamentable",
  "lamentablemente",
  "lamento",
  "lana",
  "lanza",
  "lanzado",
  "lanzamiento",
  "lanzar",
  "lapso",
  "lara",
  "larga",
  "largamente",
  "largas",
  "largo",
  "largos",
  "lata",
  "lateral",
  "laterales",
  "latina",
  "latino",
  "latinoamericana",
  "latinoamericano",
  "latinoamericanos",
  "laura",
  "laurel",
  "lavado",
  "lavar",
  "lazos",
  "leal",
  "lealtad",
  "lecciones",
  "leche",
  "lecho",
  "lector",
  "lectores",
  "lectura",
  "lecturas",
  "lee",
  "leer",
  "legado",
  "legal",
  "legales",
  "legalidad",
  "legalmente",
  "legislador",
  "legisladores",
  "legislativa",
  "legislativas",
  "legislativo",
  "legislatura",
  "legitimidad",
  "leire",
  "lejana",
  "lejano",
  "lejanos",
  "lejos",
  "lema",
  "lengua",
  "lenguaje",
  "lenguas",
  "lenta",
  "lentamente",
  "lentes",
  "lentitud",
  "lento",
  "leo",
  "leonardo",
  "leones",
  "leonor",
  "leopoldo",
  "lesiones",
  "letra",
  "letras",
  "levanta",
  "levantaba",
  "levantado",
  "levantamiento",
  "levantar",
  "levantarse",
  "levante",
  "leve",
  "levemente",
  "leves",
  "ley",
  "leyenda",
  "leyendo",
  "leyes",
  "leyre",
  "liberado",
  "liberal",
  "liberales",
  "liberalismo",
  "liberar",
  "libertad",
  "libertades",
  "libra",
  "libras",
  "libre",
  "libremente",
  "libres",
  "libro",
  "libros",
  "licencia",
  "licenciado",
  "licencias",
  "liderazgo",
  "lidia",
  "lienzo",
  "liga",
  "ligada",
  "ligado",
  "ligas",
  "ligera",
  "ligeramente",
  "ligero",
  "lima",
  "limita",
  "limitaciones",
  "limitada",
  "limitado",
  "limitar",
  "limpia",
  "limpiar",
  "limpias",
  "limpieza",
  "limpio",
  "linares",
  "linda",
  "lindo",
  "lineal",
  "linux",
  "lisa",
  "lisboa",
  "lista",
  "listas",
  "listo",
  "literalmente",
  "literaria",
  "literarias",
  "literario",
  "literarios",
  "literatura",
  "litoral",
  "litro",
  "litros",
  "llama",
  "llamaba",
  "llamaban",
  "llamada",
  "llamadas",
  "llamado",
  "llamados",
  "llamamiento",
  "llamamos",
  "llaman",
  "llamando",
  "llamar",
  "llamaron",
  "llamarse",
  "llamas",
  "llame",
  "llamo",
  "llano",
  "llanos",
  "llanto",
  "llave",
  "llaves",
  "llega",
  "llegaba",
  "llegaban",
  "llegada",
  "llegado",
  "llegados",
  "llegamos",
  "llegan",
  "llegando",
  "llegar",
  "llegara",
  "llegaron",
  "llegue",
  "lleguen",
  "lleida",
  "llena",
  "llenar",
  "llenas",
  "lleno",
  "llenos",
  "lleva",
  "llevaba",
  "llevaban",
  "llevada",
  "llevado",
  "llevamos",
  "llevan",
  "llevando",
  "llevar",
  "llevara",
  "llevarlo",
  "llevaron",
  "llevarse",
  "lleve",
  "llevo",
  "llora",
  "llorando",
  "llorar",
  "lluis",
  "lluvia",
  "lluvias",
  "lobo",
  "loca",
  "local",
  "locales",
  "localidad",
  "localidades",
  "localizar",
  "loco",
  "locos",
  "locura",
  "logra",
  "lograba",
  "logrado",
  "logran",
  "lograr",
  "lograron",
  "logro",
  "logros",
  "lola",
  "lomo",
  "londres",
  "longitud",
  "lope",
  "lorca",
  "lord",
  "lorena",
  "lorenzo",
  "louis",
  "lourdes",
  "lozano",
  "lucas",
  "luces",
  "lucha",
  "luchando",
  "luchar",
  "luchas",
  "luciano",
  "lucidez",
  "lucio",
  "luego",
  "lugar",
  "lugares",
  "luis",
  "luisa",
  "lujo",
  "luminoso",
  "luna",
  "lunar",
  "lunes",
  "luxemburgo",
  "luz",
  "machado",
  "macho",
  "madame",
  "maddi",
  "madera",
  "madre",
  "madres",
  "madrid",
  "madrugada",
  "madurez",
  "maduro",
  "maestra",
  "maestro",
  "maestros",
  "mafia",
  "magdalena",
  "magia",
  "magistrado",
  "magistrados",
  "magnitud",
  "mago",
  "mahoma",
  "maialen",
  "maite",
  "majestad",
  "mal",
  "mala",
  "malas",
  "maldita",
  "maldito",
  "maldonado",
  "males",
  "malestar",
  "maleta",
  "malika",
  "mallorca",
  "malo",
  "malos",
  "mama",
  "managua",
  "mancha",
  "manchas",
  "manda",
  "mandado",
  "mandar",
  "mandatario",
  "mandato",
  "mando",
  "mandos",
  "maneja",
  "manejar",
  "manejo",
  "manera",
  "maneras",
  "manga",
  "manifestaciones",
  "manifestado",
  "manifestantes",
  "manifestar",
  "manifestaron",
  "manifiesta",
  "manifiestan",
  "manifiesto",
  "maniobra",
  "maniobras",
  "mano",
  "manolo",
  "manos",
  "manta",
  "manteca",
  "mantener",
  "mantenerse",
  "mantenga",
  "mantenido",
  "manteniendo",
  "mantenimiento",
  "mantequilla",
  "mantiene",
  "mantienen",
  "manto",
  "mantuvieron",
  "mantuvo",
  "manual",
  "manuel",
  "manuela",
  "manzana",
  "manzanas",
  "manzano",
  "mapa",
  "mapas",
  "maquinaria",
  "mar",
  "maradona",
  "maravilla",
  "maravillas",
  "maravillosa",
  "maravilloso",
  "marc",
  "marca",
  "marcada",
  "marcado",
  "marcador",
  "marcar",
  "marcas",
  "marcel",
  "marcelo",
  "marcha",
  "marcharse",
  "marco",
  "marcos",
  "marea",
  "mares",
  "margarita",
  "margen",
  "mari",
  "maria",
  "mariam",
  "mariana",
  "mariano",
  "marido",
  "mariem",
  "marina",
  "marino",
  "marinos",
  "mario",
  "mariscal",
  "mark",
  "marketing",
  "marruecos",
  "marta",
  "marte",
  "martes",
  "martin",
  "martina",
  "martirio",
  "marx",
  "marxismo",
  "marxista",
  "mary",
  "marzo",
  "masa",
  "masas",
  "masculina",
  "masculino",
  "masiva",
  "masivo",
  "mata",
  "matado",
  "matanza",
  "matar",
  "mataron",
  "mate",
  "mateo",
  "materia",
  "material",
  "materiales",
  "materias",
  "materna",
  "maternidad",
  "matices",
  "matilde",
  "matrimonio",
  "matriz",
  "mauricio",
  "max",
  "maya",
  "mayo",
  "mayor",
  "mayores",
  "mayoritariamente",
  "mayoritario",
  "mecanismo",
  "mecanismos",
  "medalla",
  "medallas",
  "media",
  "mediados",
  "mediana",
  "mediano",
  "medianoche",
  "mediante",
  "medias",
  "medicamento",
  "medicamentos",
  "medicina",
  "medicinas",
  "medida",
  "medidas",
  "medieval",
  "medina",
  "medio",
  "medios",
  "medir",
  "mejilla",
  "mejillas",
  "mejor",
  "mejora",
  "mejorado",
  "mejoramiento",
  "mejorar",
  "mejoras",
  "mejores",
  "melilla",
  "membrana",
  "memoria",
  "memorias",
  "menciona",
  "mencionada",
  "mencionadas",
  "mencionado",
  "mencionados",
  "mencionar",
  "mendoza",
  "menem",
  "menor",
  "menores",
  "menos",
  "mensaje",
  "mensajes",
  "mensual",
  "mensuales",
  "mental",
  "mentales",
  "mentalidad",
  "mente",
  "mentira",
  "mentiras",
  "menudo",
  "mera",
  "meramente",
  "mercado",
  "mercados",
  "mercantil",
  "merced",
  "mercedes",
  "mercosur",
  "mercurio",
  "merece",
  "merecen",
  "merino",
  "meritxell",
  "mero",
  "mes",
  "mesa",
  "mesas",
  "meses",
  "meta",
  "metabolismo",
  "metal",
  "metales",
  "metas",
  "mete",
  "meter",
  "meterse",
  "metido",
  "metro",
  "metropolitana",
  "metros",
  "mexicana",
  "mexicano",
  "mexicanos",
  "mezcla",
  "mezclar",
  "miami",
  "michael",
  "michel",
  "microsoft",
  "mide",
  "miedo",
  "miel",
  "miembro",
  "miembros",
  "mientras",
  "mierda",
  "miguel",
  "mikel",
  "mil",
  "milagro",
  "milagros",
  "milenio",
  "miles",
  "militante",
  "militantes",
  "militar",
  "militares",
  "millares",
  "millas",
  "millones",
  "min",
  "mina",
  "minas",
  "mineral",
  "minerales",
  "mineros",
  "ministerial",
  "ministerio",
  "ministerios",
  "ministra",
  "ministro",
  "ministros",
  "minuto",
  "minutos",
  "miquel",
  "mira",
  "miraba",
  "miraban",
  "mirada",
  "miradas",
  "miran",
  "miranda",
  "mirando",
  "mirar",
  "miras",
  "mire",
  "mireia",
  "miren",
  "miro",
  "misa",
  "miserable",
  "miseria",
  "misiles",
  "misiones",
  "misma",
  "mismas",
  "mismo",
  "mismos",
  "miss",
  "misterio",
  "misterios",
  "misteriosa",
  "misterioso",
  "mitad",
  "mitin",
  "mito",
  "mitos",
  "mitterrand",
  "mixta",
  "moda",
  "modalidad",
  "modalidades",
  "modelo",
  "modelos",
  "moderada",
  "moderado",
  "moderna",
  "modernas",
  "modernidad",
  "moderno",
  "modernos",
  "modesta",
  "modesto",
  "modificaciones",
  "modificado",
  "modificar",
  "modo",
  "modos",
  "mohamed",
  "molde",
  "molecular",
  "molesta",
  "molestias",
  "molesto",
  "molina",
  "momento",
  "momentos",
  "monarca",
  "monasterio",
  "moncloa",
  "moneda",
  "monedas",
  "monetaria",
  "monetario",
  "monjas",
  "mono",
  "monopolio",
  "monstruo",
  "montado",
  "montaje",
  "montar",
  "monte",
  "montero",
  "montes",
  "montesinos",
  "montevideo",
  "monto",
  "montoya",
  "montserrat",
  "monumental",
  "monumento",
  "monumentos",
  "mora",
  "moral",
  "morales",
  "morena",
  "moreno",
  "morir",
  "moro",
  "mortal",
  "mortales",
  "mortalidad",
  "moscas",
  "mostraba",
  "mostrado",
  "mostrador",
  "mostrando",
  "mostrar",
  "mostraron",
  "motivaciones",
  "motivo",
  "motivos",
  "moto",
  "motor",
  "motores",
  "mover",
  "moverse",
  "movido",
  "movilidad",
  "movilizaciones",
  "movimiento",
  "movimientos",
  "mozart",
  "mozo",
  "mucha",
  "muchacha",
  "muchachas",
  "muchacho",
  "muchachos",
  "muchas",
  "mucho",
  "muchos",
  "mudo",
  "muebles",
  "muelle",
  "muere",
  "mueren",
  "muerta",
  "muertas",
  "muerte",
  "muertes",
  "muerto",
  "muertos",
  "muestra",
  "muestran",
  "muestras",
  "mueve",
  "mueven",
  "muhammad",
  "mujer",
  "mujeres",
  "multa",
  "multimedia",
  "multinacional",
  "multitud",
  "mundial",
  "mundiales",
  "mundo",
  "mundos",
  "municipal",
  "municipales",
  "municipalidad",
  "municipio",
  "municipios",
  "murcia",
  "murieron",
  "muro",
  "muros",
  "muscular",
  "musculares",
  "museo",
  "museos",
  "musical",
  "musicales",
  "muslos",
  "mustafa",
  "musulmanes",
  "mutua",
  "mutuamente",
  "mutuo",
  "muy",
  "nabil",
  "nace",
  "nacen",
  "nacer",
  "nacho",
  "nacida",
  "nacido",
  "nacidos",
  "nacimiento",
  "nacional",
  "nacionales",
  "nacionalidad",
  "nacionalismo",
  "nacionalista",
  "nacionalistas",
  "naciones",
  "nada",
  "nadia",
  "nadie",
  "nahia",
  "naima",
  "naranja",
  "narcotraficantes",
  "narices",
  "nariz",
  "narra",
  "narrador",
  "narrativa",
  "natal",
  "natalia",
  "nativos",
  "natural",
  "naturales",
  "naturaleza",
  "naturalidad",
  "naturalmente",
  "navaja",
  "naval",
  "navarra",
  "navarro",
  "nave",
  "naves",
  "navidad",
  "necesaria",
  "necesariamente",
  "necesarias",
  "necesario",
  "necesarios",
  "necesidad",
  "necesidades",
  "necesita",
  "necesitaba",
  "necesitamos",
  "necesitan",
  "necesito",
  "negado",
  "negar",
  "negativa",
  "negativas",
  "negativo",
  "negativos",
  "negociaciones",
  "negociar",
  "negocio",
  "negocios",
  "negra",
  "negras",
  "negro",
  "negros",
  "nelson",
  "nerea",
  "nervios",
  "nerviosa",
  "nervioso",
  "newton",
  "nicaragua",
  "niebla",
  "niega",
  "niegan",
  "nieto",
  "nietos",
  "nieve",
  "nieves",
  "ninguna",
  "ninguno",
  "nivel",
  "niveles",
  "noa",
  "nobel",
  "noble",
  "nobles",
  "nobleza",
  "noche",
  "noches",
  "nocturna",
  "nocturno",
  "noelia",
  "nombrado",
  "nombramiento",
  "nombrar",
  "nombre",
  "nombres",
  "noor",
  "nora",
  "norma",
  "normal",
  "normales",
  "normalidad",
  "normalmente",
  "norman",
  "normas",
  "normativa",
  "noroeste",
  "norte",
  "norteamericana",
  "norteamericanas",
  "norteamericano",
  "norteamericanos",
  "noruega",
  "nosotras",
  "nosotros",
  "nostalgia",
  "nota",
  "notable",
  "notablemente",
  "notables",
  "notar",
  "notas",
  "noticia",
  "noticias",
  "nour",
  "novedad",
  "novedades",
  "novela",
  "novelas",
  "novelista",
  "noventa",
  "novia",
  "noviembre",
  "novio",
  "novios",
  "nube",
  "nubes",
  "nuboso",
  "nuca",
  "nuclear",
  "nucleares",
  "nudo",
  "nuestra",
  "nuestras",
  "nuestro",
  "nuestros",
  "nueva",
  "nuevamente",
  "nuevas",
  "nueve",
  "nuevo",
  "nuevos",
  "numerosas",
  "numerosos",
  "nunca",
  "nuria",
  "nutrientes",
  "obama",
  "obedece",
  "obediencia",
  "obesidad",
  "obispo",
  "obispos",
  "objetiva",
  "objetividad",
  "objetivo",
  "objetivos",
  "objeto",
  "objetos",
  "obliga",
  "obligaciones",
  "obligada",
  "obligado",
  "obligados",
  "obligan",
  "obligatoria",
  "obligatorio",
  "obra",
  "obras",
  "obrera",
  "obreras",
  "obrero",
  "obreros",
  "observa",
  "observaba",
  "observaciones",
  "observado",
  "observador",
  "observadores",
  "observamos",
  "observan",
  "observando",
  "observar",
  "obstante",
  "obtener",
  "obtenida",
  "obtenido",
  "obtenidos",
  "obtiene",
  "obtienen",
  "obtuvieron",
  "obtuvo",
  "obviamente",
  "obvio",
  "ocasiones",
  "occidental",
  "occidentales",
  "occidente",
  "ochenta",
  "ocho",
  "ocio",
  "octavio",
  "octavo",
  "octubre",
  "oculta",
  "ocultar",
  "oculto",
  "ocupa",
  "ocupaba",
  "ocupada",
  "ocupado",
  "ocupados",
  "ocupan",
  "ocupar",
  "ocurra",
  "ocurre",
  "ocurren",
  "ocurrido",
  "ocurriendo",
  "ocurrir",
  "odio",
  "oeste",
  "ofensiva",
  "oferta",
  "ofertas",
  "off",
  "oficial",
  "oficiales",
  "oficialmente",
  "oficina",
  "oficinas",
  "oficio",
  "oficios",
  "ofrece",
  "ofrecen",
  "ofrecer",
  "ofrecido",
  "ofreciendo",
  "ofrecieron",
  "oiga",
  "oigo",
  "ojo",
  "ojos",
  "ola",
  "olas",
  "olatz",
  "olga",
  "oliva",
  "olla",
  "olor",
  "olores",
  "olvida",
  "olvidado",
  "olvidar",
  "olvidarse",
  "olvide",
  "olvido",
  "omar",
  "once",
  "onda",
  "ondas",
  "onu",
  "opciones",
  "opera",
  "operaciones",
  "operador",
  "operadores",
  "operan",
  "operar",
  "operativo",
  "operativos",
  "opina",
  "opiniones",
  "opone",
  "oportunidad",
  "oportunidades",
  "oportuno",
  "opositores",
  "optar",
  "optimismo",
  "optimista",
  "opuesta",
  "opuesto",
  "oraciones",
  "oral",
  "orden",
  "ordena",
  "ordenado",
  "ordenador",
  "ordenadores",
  "ordenamiento",
  "ordenar",
  "ordinaria",
  "ordinario",
  "oreja",
  "orejas",
  "organismo",
  "organismos",
  "organiza",
  "organizaciones",
  "organizada",
  "organizado",
  "organizadores",
  "organizados",
  "organizar",
  "orgullo",
  "orgulloso",
  "oriental",
  "orientales",
  "oriente",
  "origen",
  "origina",
  "original",
  "originales",
  "originalidad",
  "orilla",
  "orillas",
  "orina",
  "oriol",
  "orlando",
  "oro",
  "orquesta",
  "ortega",
  "ortiz",
  "oscar",
  "oscura",
  "oscuras",
  "oscuridad",
  "oscuro",
  "oscuros",
  "oso",
  "osvaldo",
  "otan",
  "otero",
  "otorga",
  "otorgado",
  "otorgar",
  "otra",
  "otras",
  "otro",
  "otros",
  "oviedo",
  "oye",
  "oyentes",
  "pablo",
  "pacheco",
  "paciencia",
  "paciente",
  "pacientes",
  "paco",
  "pacto",
  "pactos",
  "padece",
  "padecen",
  "padecer",
  "padre",
  "padres",
  "paga",
  "pagado",
  "pagan",
  "pagando",
  "pagar",
  "pago",
  "pagos",
  "paisaje",
  "paisajes",
  "paja",
  "palabra",
  "palabras",
  "palacio",
  "palacios",
  "palencia",
  "palestina",
  "palestino",
  "palestinos",
  "palma",
  "palmas",
  "palo",
  "paloma",
  "palos",
  "pamplona",
  "pan",
  "panorama",
  "pantalla",
  "pantallas",
  "pantalones",
  "papa",
  "papas",
  "papel",
  "papeles",
  "paquete",
  "paquetes",
  "par",
  "para",
  "parada",
  "paradigma",
  "parado",
  "paradoja",
  "parados",
  "paraguay",
  "paralela",
  "paralelamente",
  "paralelo",
  "parar",
  "parcial",
  "parciales",
  "parcialmente",
  "pardo",
  "parece",
  "parecen",
  "parecer",
  "parecida",
  "parecido",
  "parecidos",
  "pareciera",
  "pared",
  "paredes",
  "pareja",
  "parejas",
  "pares",
  "parezca",
  "parientes",
  "parlamentaria",
  "parlamentario",
  "parlamentarios",
  "parlamento",
  "paro",
  "parque",
  "parques",
  "parra",
  "parroquia",
  "parte",
  "partes",
  "participa",
  "participado",
  "participan",
  "participantes",
  "participar",
  "participaron",
  "particular",
  "particulares",
  "particularmente",
  "partida",
  "partidario",
  "partidarios",
  "partidas",
  "partido",
  "partidos",
  "partiendo",
  "partir",
  "parto",
  "pasa",
  "pasaba",
  "pasaban",
  "pasada",
  "pasadas",
  "pasado",
  "pasados",
  "pasaje",
  "pasajeros",
  "pasajes",
  "pasamos",
  "pasan",
  "pasando",
  "pasaporte",
  "pasar",
  "pasara",
  "pasaron",
  "pascual",
  "pase",
  "pasear",
  "paseo",
  "paseos",
  "pasillo",
  "pasillos",
  "pasiones",
  "paso",
  "pasos",
  "pasta",
  "pasto",
  "pastor",
  "pata",
  "patas",
  "patatas",
  "patente",
  "patentes",
  "patio",
  "patria",
  "patricia",
  "patricio",
  "patrimonio",
  "patrocinio",
  "patronal",
  "patrones",
  "pau",
  "paul",
  "paula",
  "paulatinamente",
  "paulina",
  "paulo",
  "pausa",
  "pautas",
  "payaso",
  "paz",
  "pecado",
  "pecados",
  "peces",
  "pecho",
  "pechos",
  "peculiar",
  "pedazo",
  "pedazos",
  "pedido",
  "pedir",
  "pedirle",
  "pedro",
  "pegado",
  "pelayo",
  "pelea",
  "pelear",
  "peligro",
  "peligros",
  "peligrosa",
  "peligrosas",
  "peligroso",
  "peligrosos",
  "pelo",
  "pelos",
  "pelota",
  "pena",
  "penal",
  "penales",
  "penas",
  "pendiente",
  "pendientes",
  "penetrar",
  "pensaba",
  "pensado",
  "pensamiento",
  "pensamientos",
  "pensamos",
  "pensando",
  "pensar",
  "pensiones",
  "penumbra",
  "peor",
  "peores",
  "pepe",
  "percibe",
  "percibir",
  "perder",
  "perderse",
  "perdida",
  "perdido",
  "perdidos",
  "perdiendo",
  "perdieron",
  "perdona",
  "pere",
  "pereira",
  "perejil",
  "perfecta",
  "perfectamente",
  "perfecto",
  "perfil",
  "perfume",
  "periodismo",
  "periodista",
  "periodistas",
  "periodo",
  "periodos",
  "perjuicio",
  "permanece",
  "permanecen",
  "permanecer",
  "permanecido",
  "permanencia",
  "permanente",
  "permanentemente",
  "permanentes",
  "permiso",
  "permisos",
  "permita",
  "permitan",
  "permite",
  "permiten",
  "permitido",
  "permitiendo",
  "permitieron",
  "permitir",
  "pero",
  "perpetua",
  "perro",
  "perros",
  "persigue",
  "persona",
  "personaje",
  "personajes",
  "personal",
  "personales",
  "personalidad",
  "personalidades",
  "personalmente",
  "personas",
  "perspectiva",
  "perspectivas",
  "pertenece",
  "pertenecen",
  "pertenecer",
  "perteneciente",
  "pertenecientes",
  "pertenencia",
  "pertinentes",
  "peruana",
  "peruano",
  "peruanos",
  "pesa",
  "pesada",
  "pesadilla",
  "pesado",
  "pesados",
  "pesar",
  "pesca",
  "pescado",
  "pescadores",
  "pescados",
  "pese",
  "peseta",
  "pesetas",
  "peso",
  "pesos",
  "peste",
  "peter",
  "peticiones",
  "petrolera",
  "pez",
  "pianista",
  "piano",
  "pib",
  "picada",
  "picado",
  "picasso",
  "pico",
  "pide",
  "piden",
  "pidiendo",
  "pidieron",
  "pido",
  "pie",
  "piedad",
  "piedra",
  "piedras",
  "piel",
  "piensa",
  "piensan",
  "piensas",
  "piense",
  "pienso",
  "pierda",
  "pierde",
  "pierden",
  "pierna",
  "piernas",
  "pierre",
  "pies",
  "pieza",
  "piezas",
  "pilar",
  "pilares",
  "piloto",
  "pilotos",
  "pimienta",
  "pino",
  "pinochet",
  "pinos",
  "pinta",
  "pintado",
  "pintar",
  "pintor",
  "pintores",
  "pintura",
  "pinturas",
  "pipa",
  "piscina",
  "piso",
  "pisos",
  "pista",
  "pistas",
  "pistola",
  "pizarro",
  "placa",
  "placas",
  "placer",
  "plan",
  "plana",
  "plancha",
  "planes",
  "planeta",
  "planetas",
  "plano",
  "planos",
  "planta",
  "plantas",
  "plantea",
  "planteado",
  "planteamiento",
  "planteamientos",
  "plantean",
  "plantear",
  "plantearse",
  "plantel",
  "plantilla",
  "plata",
  "plataforma",
  "plato",
  "platos",
  "playa",
  "playas",
  "plaza",
  "plazas",
  "plazo",
  "plazos",
  "plena",
  "plenamente",
  "plenitud",
  "pleno",
  "plomo",
  "pluma",
  "plumas",
  "plural",
  "pnv",
  "poblaciones",
  "poblado",
  "pobladores",
  "pobre",
  "pobres",
  "pobreza",
  "poca",
  "pocas",
  "poco",
  "pocos",
  "podamos",
  "podemos",
  "poder",
  "poderes",
  "poderosa",
  "poderoso",
  "poderosos",
  "podido",
  "podremos",
  "poema",
  "poemas",
  "poeta",
  "poetas",
  "pol",
  "policial",
  "policiales",
  "pollo",
  "polo",
  "polonia",
  "polvo",
  "ponce",
  "pone",
  "ponemos",
  "ponen",
  "ponencia",
  "poner",
  "ponerle",
  "ponerse",
  "ponga",
  "pongan",
  "pongo",
  "poniendo",
  "pop",
  "popular",
  "populares",
  "popularidad",
  "poquito",
  "porcentaje",
  "porcentajes",
  "porciones",
  "porque",
  "porta",
  "portada",
  "portal",
  "portavoces",
  "portavoz",
  "portero",
  "portugal",
  "portuguesa",
  "porvenir",
  "posada",
  "posee",
  "poseen",
  "poseer",
  "posguerra",
  "posibilidad",
  "posibilidades",
  "posible",
  "posiblemente",
  "posibles",
  "posiciones",
  "positiva",
  "positivas",
  "positivo",
  "positivos",
  "post",
  "posterior",
  "posteriores",
  "posteriormente",
  "postre",
  "postulados",
  "postura",
  "posturas",
  "potable",
  "potencia",
  "potencial",
  "potenciales",
  "potenciar",
  "potencias",
  "potente",
  "pozo",
  "practica",
  "practicar",
  "prado",
  "precauciones",
  "precedente",
  "precedentes",
  "precio",
  "precios",
  "precioso",
  "precipitaciones",
  "precisa",
  "precisamente",
  "precisar",
  "precisas",
  "preciso",
  "precisos",
  "precoz",
  "predominio",
  "preferencia",
  "preferencias",
  "preferentemente",
  "preferible",
  "preferido",
  "prefiere",
  "prefieren",
  "prefiero",
  "pregunta",
  "preguntaba",
  "preguntado",
  "preguntar",
  "preguntarle",
  "preguntarse",
  "preguntas",
  "pregunto",
  "prejuicios",
  "premio",
  "premios",
  "prenda",
  "prendas",
  "prensa",
  "preocupa",
  "preocupaciones",
  "preocupado",
  "preocupante",
  "preocuparse",
  "preocupes",
  "prepara",
  "preparada",
  "preparado",
  "preparados",
  "preparan",
  "preparando",
  "preparar",
  "preparativos",
  "presa",
  "prescindir",
  "presencia",
  "presenta",
  "presentaba",
  "presentaciones",
  "presentada",
  "presentadas",
  "presentado",
  "presentados",
  "presentan",
  "presentar",
  "presentaron",
  "presentarse",
  "presente",
  "presenten",
  "presentes",
  "preservar",
  "preside",
  "presidencia",
  "presidencial",
  "presidenciales",
  "presidenta",
  "presidente",
  "presidentes",
  "presidida",
  "presidido",
  "presiones",
  "preso",
  "presos",
  "press",
  "presta",
  "prestaciones",
  "prestado",
  "prestar",
  "prestigio",
  "presunta",
  "presuntamente",
  "presunto",
  "presuntos",
  "presupuesto",
  "presupuestos",
  "pretende",
  "pretenden",
  "pretender",
  "pretensiones",
  "pretexto",
  "prevalencia",
  "prevenir",
  "preventiva",
  "prever",
  "previa",
  "previamente",
  "previas",
  "previo",
  "previos",
  "previsible",
  "previsiones",
  "prevista",
  "previstas",
  "previsto",
  "previstos",
  "prieto",
  "prima",
  "primaria",
  "primarias",
  "primario",
  "primas",
  "primavera",
  "primer",
  "primera",
  "primeras",
  "primero",
  "primeros",
  "primitiva",
  "primitivo",
  "primo",
  "primordial",
  "princesa",
  "principal",
  "principales",
  "principalmente",
  "principio",
  "principios",
  "prioridad",
  "prioridades",
  "prisa",
  "prisionero",
  "prisioneros",
  "privada",
  "privadas",
  "privado",
  "privados",
  "privilegio",
  "privilegios",
  "probabilidad",
  "probabilidades",
  "probable",
  "probablemente",
  "probado",
  "probar",
  "problema",
  "problemas",
  "procede",
  "proceden",
  "procedencia",
  "procedente",
  "procedentes",
  "proceder",
  "procedimiento",
  "procedimientos",
  "procesado",
  "procesados",
  "procesamiento",
  "proceso",
  "procesos",
  "procura",
  "procurador",
  "producciones",
  "produce",
  "producen",
  "producida",
  "producidas",
  "producido",
  "producidos",
  "produciendo",
  "producir",
  "producirse",
  "productiva",
  "productivas",
  "productividad",
  "productivo",
  "productivos",
  "producto",
  "productor",
  "productora",
  "productores",
  "productos",
  "produjeron",
  "produjo",
  "produzca",
  "profesional",
  "profesionales",
  "profesor",
  "profesora",
  "profesorado",
  "profesores",
  "profunda",
  "profundamente",
  "profundas",
  "profundidad",
  "profundizar",
  "profundo",
  "profundos",
  "programa",
  "programas",
  "progresista",
  "progresiva",
  "progresivamente",
  "progresivo",
  "progreso",
  "prohibido",
  "prolongada",
  "prolongado",
  "promedio",
  "promesa",
  "promesas",
  "promete",
  "prometido",
  "promotores",
  "promover",
  "pronto",
  "pronunciado",
  "pronunciar",
  "propaganda",
  "propia",
  "propiamente",
  "propias",
  "propiedad",
  "propiedades",
  "propietario",
  "propietarios",
  "propio",
  "propios",
  "propone",
  "proponen",
  "proponer",
  "proporciona",
  "proporcional",
  "proporcionan",
  "proporcionar",
  "proporciones",
  "proposiciones",
  "propuesta",
  "propuestas",
  "propuesto",
  "propuso",
  "prosa",
  "prosperidad",
  "protagonismo",
  "protagonista",
  "protagonistas",
  "protector",
  "protege",
  "proteger",
  "protegido",
  "protesta",
  "protestar",
  "protestas",
  "protocolo",
  "provecho",
  "proveedores",
  "provenientes",
  "proviene",
  "provienen",
  "provincia",
  "provincial",
  "provinciales",
  "provincias",
  "provisional",
  "provoca",
  "provocada",
  "provocado",
  "provocan",
  "provocando",
  "provocar",
  "proximidad",
  "proyecciones",
  "proyecta",
  "proyecto",
  "proyectos",
  "prudencia",
  "prudente",
  "prueba",
  "pruebas",
  "psicosis",
  "psiquiatra",
  "psoe",
  "ptas",
  "publica",
  "publicaciones",
  "publicada",
  "publicadas",
  "publicado",
  "publicados",
  "publicar",
  "publicidad",
  "publicitaria",
  "publicitario",
  "pude",
  "pudiendo",
  "pudiera",
  "pudieran",
  "pudieron",
  "pudiese",
  "pudimos",
  "pudo",
  "puebla",
  "pueblo",
  "pueblos",
  "pueda",
  "puedan",
  "puede",
  "pueden",
  "puedes",
  "puedo",
  "puente",
  "puentes",
  "puerta",
  "puertas",
  "puerto",
  "puertos",
  "pues",
  "puesta",
  "puestas",
  "puesto",
  "puestos",
  "pugna",
  "pujol",
  "pulmones",
  "pulso",
  "punta",
  "puntas",
  "punto",
  "puntos",
  "pura",
  "puramente",
  "pureza",
  "puro",
  "puros",
  "puse",
  "pusieron",
  "puso",
  "puta",
  "queda",
  "quedaba",
  "quedaban",
  "quedado",
  "quedamos",
  "quedan",
  "quedando",
  "quedar",
  "quedara",
  "quedarme",
  "quedaron",
  "quedarse",
  "quede",
  "queden",
  "quedo",
  "quehacer",
  "queja",
  "quejas",
  "quema",
  "querella",
  "queremos",
  "querer",
  "querida",
  "querido",
  "queriendo",
  "queso",
  "quiebra",
  "quien",
  "quienes",
  "quiera",
  "quieran",
  "quieras",
  "quiere",
  "quieren",
  "quieres",
  "quiero",
  "quieto",
  "quijote",
  "quince",
  "quinientos",
  "quinta",
  "quintana",
  "quinto",
  "quise",
  "quisiera",
  "quisieron",
  "quiso",
  "quita",
  "quitado",
  "quitar",
  "quito",
  "rabia",
  "rachid",
  "rachida",
  "racing",
  "racional",
  "racionalidad",
  "radica",
  "radical",
  "radicales",
  "radicalmente",
  "radio",
  "rafa",
  "rafael",
  "rafaela",
  "rahma",
  "rallado",
  "rama",
  "ramas",
  "ramiro",
  "ramo",
  "ramona",
  "ramos",
  "rango",
  "rapidez",
  "raquel",
  "rara",
  "raras",
  "raro",
  "rasgo",
  "rasgos",
  "rastro",
  "ratas",
  "rato",
  "ratos",
  "raya",
  "rayan",
  "rayo",
  "rayos",
  "raza",
  "razas",
  "razonable",
  "razonamiento",
  "razones",
  "reaccionar",
  "reacciones",
  "reagan",
  "real",
  "reales",
  "realice",
  "realidad",
  "realidades",
  "realismo",
  "realista",
  "realiza",
  "realizada",
  "realizadas",
  "realizado",
  "realizador",
  "realizados",
  "realizan",
  "realizando",
  "realizar",
  "realizaron",
  "realizarse",
  "realmente",
  "rebaja",
  "rebeca",
  "rebelde",
  "rebeldes",
  "receptor",
  "receptores",
  "receta",
  "recetas",
  "rechaza",
  "rechazado",
  "rechazar",
  "rechazo",
  "recibe",
  "reciben",
  "recibida",
  "recibido",
  "recibidos",
  "recibiendo",
  "recibieron",
  "recibir",
  "recibo",
  "reciente",
  "recientemente",
  "recientes",
  "recinto",
  "recipiente",
  "reclama",
  "reclaman",
  "reclamar",
  "reclamo",
  "recoge",
  "recogen",
  "recoger",
  "recogida",
  "recogido",
  "recomendable",
  "recomendaciones",
  "recomienda",
  "reconoce",
  "reconocen",
  "reconocer",
  "reconocida",
  "reconocido",
  "reconocidos",
  "reconocimiento",
  "reconstruir",
  "recordaba",
  "recordando",
  "recordar",
  "recordemos",
  "recorre",
  "recorrer",
  "recorrido",
  "recorte",
  "recortes",
  "recta",
  "recto",
  "rector",
  "recuento",
  "recuerda",
  "recuerdan",
  "recuerde",
  "recuerdo",
  "recuerdos",
  "recupera",
  "recuperado",
  "recuperar",
  "recurrir",
  "recurso",
  "recursos",
  "red",
  "redactor",
  "redes",
  "redonda",
  "redondo",
  "reduce",
  "reducida",
  "reducido",
  "reducir",
  "redujo",
  "referencia",
  "referencias",
  "referente",
  "referentes",
  "referido",
  "referirse",
  "refiere",
  "refieren",
  "refiero",
  "refleja",
  "reflejan",
  "reflejo",
  "reflejos",
  "reflexionar",
  "reflexiones",
  "reforma",
  "reformas",
  "reforzar",
  "refuerzo",
  "refugiados",
  "refugio",
  "regalo",
  "regalos",
  "regional",
  "regionales",
  "regiones",
  "registra",
  "registrado",
  "registrados",
  "registrar",
  "registraron",
  "registro",
  "registros",
  "regla",
  "reglamento",
  "reglas",
  "regresa",
  "regresar",
  "regreso",
  "regula",
  "regular",
  "regulares",
  "rehenes",
  "reina",
  "reinado",
  "reino",
  "reivindicaciones",
  "relaciona",
  "relacionada",
  "relacionadas",
  "relacionado",
  "relacionados",
  "relaciones",
  "relata",
  "relativa",
  "relativamente",
  "relativas",
  "relativo",
  "relativos",
  "relato",
  "relatos",
  "relevancia",
  "relevante",
  "relevantes",
  "relevo",
  "relieve",
  "religiones",
  "religiosa",
  "religiosas",
  "religioso",
  "religiosos",
  "relleno",
  "reloj",
  "relojes",
  "remate",
  "remedio",
  "remedios",
  "remoto",
  "renacimiento",
  "renault",
  "rencor",
  "rendimiento",
  "rendimientos",
  "rendir",
  "renfe",
  "renovar",
  "renta",
  "rentabilidad",
  "rentable",
  "rentas",
  "renuncia",
  "renunciar",
  "reparar",
  "reparto",
  "repente",
  "repercusiones",
  "repertorio",
  "repetidas",
  "repetido",
  "repetir",
  "repite",
  "repito",
  "reportaje",
  "reposo",
  "representa",
  "representaba",
  "representaciones",
  "representada",
  "representado",
  "representados",
  "representan",
  "representante",
  "representantes",
  "representar",
  "reproducir",
  "republicana",
  "republicano",
  "republicanos",
  "requerimientos",
  "requiere",
  "requieren",
  "requisito",
  "requisitos",
  "resaltar",
  "rescatar",
  "rescate",
  "reserva",
  "reservado",
  "reservados",
  "reservas",
  "reside",
  "residencia",
  "residente",
  "residentes",
  "residuos",
  "resiste",
  "resistencia",
  "resistir",
  "resoluciones",
  "resolver",
  "resonancia",
  "respaldo",
  "respecta",
  "respectivamente",
  "respectivas",
  "respectivos",
  "respecto",
  "respetar",
  "respeto",
  "respirar",
  "responde",
  "responden",
  "responder",
  "responsabilidad",
  "responsabilidades",
  "responsable",
  "responsables",
  "respuesta",
  "respuestas",
  "resta",
  "restante",
  "restantes",
  "restaurante",
  "restaurantes",
  "resto",
  "restos",
  "restricciones",
  "resuelto",
  "resuelve",
  "resulta",
  "resultaba",
  "resultado",
  "resultados",
  "resultan",
  "resultante",
  "resultar",
  "resultaron",
  "resulte",
  "resume",
  "resumen",
  "retira",
  "retirada",
  "retirado",
  "retirar",
  "retirarse",
  "retiro",
  "reto",
  "retorno",
  "retraso",
  "retrato",
  "retratos",
  "retroceso",
  "reunido",
  "reunidos",
  "reunieron",
  "reuniones",
  "reunir",
  "reunirse",
  "reuter",
  "revela",
  "revelado",
  "revelan",
  "revelar",
  "revisar",
  "revista",
  "revistas",
  "revolucionaria",
  "revolucionario",
  "revolucionarios",
  "rey",
  "reyes",
  "ribera",
  "rica",
  "ricardo",
  "ricas",
  "richard",
  "rico",
  "ricos",
  "riego",
  "riendo",
  "riesgo",
  "riesgos",
  "rige",
  "rigidez",
  "rigor",
  "riguroso",
  "rincones",
  "rioja",
  "riqueza",
  "riquezas",
  "risa",
  "risas",
  "ritmo",
  "ritmos",
  "rito",
  "ritos",
  "ritual",
  "rival",
  "rivales",
  "rivas",
  "river",
  "rivera",
  "robado",
  "robar",
  "robert",
  "roberto",
  "robles",
  "robo",
  "roca",
  "rocas",
  "rock",
  "rodaje",
  "rodar",
  "rodea",
  "rodeada",
  "rodeado",
  "rodean",
  "rodilla",
  "rodillas",
  "rodolfo",
  "rodrigo",
  "rogelio",
  "roger",
  "roja",
  "rojas",
  "rojo",
  "rojos",
  "rol",
  "roma",
  "romana",
  "romano",
  "romanos",
  "romero",
  "rompe",
  "romper",
  "ron",
  "ronald",
  "ronda",
  "ropa",
  "ropas",
  "roque",
  "rosa",
  "rosales",
  "rosario",
  "rosas",
  "rostro",
  "rostros",
  "rota",
  "roto",
  "rtve",
  "ruben",
  "rubia",
  "rubio",
  "rueda",
  "ruedas",
  "ruedo",
  "ruego",
  "ruido",
  "ruidos",
  "ruina",
  "ruinas",
  "ruiz",
  "rumbo",
  "rumor",
  "rumores",
  "ruptura",
  "rural",
  "rurales",
  "rusa",
  "rusia",
  "ruso",
  "rusos",
  "ruta",
  "rutas",
  "rutina",
  "sabe",
  "sabemos",
  "saben",
  "saber",
  "saberlo",
  "sabes",
  "sabido",
  "sabiendo",
  "sabio",
  "sabios",
  "sabor",
  "saca",
  "sacaba",
  "sacado",
  "sacando",
  "sacar",
  "sacerdote",
  "sacerdotes",
  "saco",
  "sacrificio",
  "sacrificios",
  "sagrada",
  "sagrado",
  "said",
  "saida",
  "saint",
  "sainz",
  "sal",
  "sala",
  "salamanca",
  "salarial",
  "salario",
  "salarios",
  "salas",
  "salazar",
  "saldo",
  "sale",
  "salen",
  "sales",
  "salga",
  "salida",
  "salidas",
  "salido",
  "saliendo",
  "salieron",
  "salimos",
  "salinas",
  "salir",
  "saliva",
  "salma",
  "salones",
  "salsa",
  "salta",
  "saltar",
  "salto",
  "saltos",
  "salud",
  "saludable",
  "saludar",
  "saludo",
  "salva",
  "salvado",
  "salvador",
  "salvaje",
  "salvajes",
  "salvar",
  "salvo",
  "samira",
  "samper",
  "samuel",
  "san",
  "sana",
  "sancho",
  "sanciones",
  "sandinista",
  "sandra",
  "saneamiento",
  "sangre",
  "sanidad",
  "sanitaria",
  "sanitarias",
  "sanitario",
  "sanitarios",
  "sano",
  "sant",
  "santa",
  "santander",
  "santiago",
  "santo",
  "santos",
  "santuario",
  "sanz",
  "sara",
  "sarajevo",
  "sargento",
  "satisfacer",
  "satisfecho",
  "sean",
  "seas",
  "seca",
  "secas",
  "secciones",
  "seco",
  "secos",
  "secreta",
  "secretaria",
  "secretario",
  "secreto",
  "secretos",
  "sector",
  "sectores",
  "secuencia",
  "secuencias",
  "secuestrado",
  "secuestro",
  "secundaria",
  "secundario",
  "secundarios",
  "sed",
  "seda",
  "sede",
  "segmento",
  "segmentos",
  "segovia",
  "seguida",
  "seguido",
  "seguidores",
  "seguidos",
  "seguimiento",
  "seguimos",
  "seguir",
  "segunda",
  "segundo",
  "segundos",
  "segura",
  "seguramente",
  "seguridad",
  "seguro",
  "seguros",
  "seis",
  "seleccionado",
  "seleccionados",
  "seleccionar",
  "sello",
  "selva",
  "semana",
  "semanal",
  "semanario",
  "semanas",
  "semejante",
  "semejantes",
  "semejanza",
  "semestre",
  "semifinales",
  "semilla",
  "semillas",
  "seminario",
  "senado",
  "senador",
  "senadores",
  "sencilla",
  "sencillamente",
  "sencillez",
  "sencillo",
  "senda",
  "sendas",
  "sendero",
  "seno",
  "senos",
  "sensaciones",
  "sensibilidad",
  "sensible",
  "sensibles",
  "sentada",
  "sentado",
  "sentados",
  "sentarse",
  "sentencia",
  "sentencias",
  "sentido",
  "sentidos",
  "sentimental",
  "sentimiento",
  "sentimientos",
  "sentimos",
  "sentir",
  "sentirse",
  "sepa",
  "separa",
  "separadas",
  "separado",
  "separados",
  "separan",
  "separar",
  "septiembre",
  "serbios",
  "serena",
  "serenidad",
  "sereno",
  "seres",
  "sergi",
  "sergio",
  "seria",
  "seriamente",
  "serias",
  "serie",
  "seriedad",
  "series",
  "serio",
  "serios",
  "serlo",
  "serpiente",
  "serra",
  "serrano",
  "servicio",
  "servicios",
  "servido",
  "servidor",
  "servidores",
  "servir",
  "sesenta",
  "sesiones",
  "setenta",
  "setiembre",
  "severa",
  "severo",
  "sevilla",
  "sexo",
  "sexos",
  "sexta",
  "sexto",
  "sexual",
  "sexuales",
  "sexualidad",
  "show",
  "sida",
  "sido",
  "siembra",
  "siempre",
  "siendo",
  "sienta",
  "siente",
  "sienten",
  "siento",
  "sierra",
  "siete",
  "siga",
  "sigan",
  "siglo",
  "siglos",
  "significa",
  "significaba",
  "significado",
  "significados",
  "significar",
  "significativa",
  "significativamente",
  "significativas",
  "significativo",
  "significativos",
  "signo",
  "signos",
  "sigo",
  "sigue",
  "siguen",
  "siguiendo",
  "siguiente",
  "siguientes",
  "siguieron",
  "silencio",
  "silenciosa",
  "silencioso",
  "silla",
  "sillas",
  "silueta",
  "silva",
  "silvestre",
  "silvia",
  "similar",
  "similares",
  "simple",
  "simplemente",
  "simples",
  "sin",
  "sinceramente",
  "sinceridad",
  "sincero",
  "sindical",
  "sindicales",
  "sindicato",
  "sindicatos",
  "singular",
  "siniestro",
  "sino",
  "sintiendo",
  "siquiera",
  "sirva",
  "sirve",
  "sirven",
  "sirvieron",
  "sistema",
  "sistemas",
  "sitio",
  "sitios",
  "situaciones",
  "situada",
  "situadas",
  "situado",
  "situados",
  "situar",
  "situarse",
  "smith",
  "soberano",
  "soberbia",
  "sobra",
  "sobre",
  "sobrevivir",
  "sobrino",
  "social",
  "sociales",
  "socialismo",
  "socialista",
  "socialistas",
  "socialmente",
  "sociedad",
  "sociedades",
  "socio",
  "socios",
  "socorro",
  "sodio",
  "software",
  "sohora",
  "sois",
  "sol",
  "sola",
  "solamente",
  "solana",
  "solar",
  "solares",
  "solas",
  "soldado",
  "soldados",
  "soledad",
  "solemne",
  "solicita",
  "solicitado",
  "solicitar",
  "solicitud",
  "solicitudes",
  "solidaridad",
  "solitario",
  "solo",
  "solos",
  "soltar",
  "solucionar",
  "soluciones",
  "sombra",
  "sombras",
  "sombrero",
  "someterse",
  "sometida",
  "sometido",
  "sometidos",
  "somos",
  "sonaba",
  "sonar",
  "sonia",
  "sonido",
  "sonidos",
  "sonora",
  "sonoro",
  "sonriendo",
  "sonriente",
  "sonrisa",
  "sonsoles",
  "sopa",
  "soportar",
  "soporte",
  "sor",
  "soraya",
  "sordo",
  "soria",
  "sorprende",
  "sorprendente",
  "sorprendido",
  "sorpresa",
  "sorpresas",
  "sorteo",
  "sos",
  "sosa",
  "sospecha",
  "sospechar",
  "sospechas",
  "sospechoso",
  "sospechosos",
  "sostener",
  "sostenido",
  "sostiene",
  "sostienen",
  "sostuvo",
  "soto",
  "stalin",
  "status",
  "street",
  "suave",
  "suavemente",
  "suaves",
  "suavidad",
  "subasta",
  "sube",
  "subida",
  "subido",
  "subiendo",
  "subieron",
  "subir",
  "subraya",
  "subrayar",
  "subsecretario",
  "subvenciones",
  "sucede",
  "suceden",
  "suceder",
  "sucedido",
  "sucediendo",
  "sucesivamente",
  "sucesivas",
  "sucesivos",
  "suceso",
  "sucesor",
  "sucesos",
  "sucia",
  "sucio",
  "sudor",
  "suecia",
  "sueldo",
  "sueldos",
  "suele",
  "suelen",
  "suelo",
  "suelos",
  "suelta",
  "suena",
  "suerte",
  "sufian",
  "suficiente",
  "suficientemente",
  "suficientes",
  "sufre",
  "sufren",
  "sufrido",
  "sufriendo",
  "sufrieron",
  "sufrimiento",
  "sufrir",
  "sugerencias",
  "sugiere",
  "suicida",
  "suicidio",
  "suiza",
  "suizo",
  "sujeta",
  "sujeto",
  "sujetos",
  "suma",
  "sumamente",
  "suman",
  "sumar",
  "sumario",
  "suministro",
  "sumo",
  "supe",
  "supera",
  "superado",
  "superan",
  "superar",
  "superficial",
  "superficie",
  "superficies",
  "superior",
  "superiores",
  "superioridad",
  "supervivencia",
  "supiera",
  "supo",
  "supone",
  "suponen",
  "suponer",
  "supongo",
  "suprema",
  "supremo",
  "supuesta",
  "supuestamente",
  "supuesto",
  "supuestos",
  "supuso",
  "sur",
  "sureste",
  "surge",
  "surgen",
  "surgido",
  "surgieron",
  "surgir",
  "susana",
  "susceptibles",
  "suscrito",
  "suspender",
  "suspendido",
  "sustancia",
  "sustancial",
  "sustancialmente",
  "sustancias",
  "sustituido",
  "sustituir",
  "sustituye",
  "susto",
  "sutil",
  "suya",
  "suyas",
  "suyo",
  "suyos",
  "tabaco",
  "tabla",
  "tablas",
  "tacto",
  "talante",
  "talento",
  "tales",
  "talla",
  "taller",
  "talleres",
  "tampoco",
  "tango",
  "tanques",
  "tanta",
  "tantas",
  "tanto",
  "tantos",
  "tapa",
  "tarde",
  "tardes",
  "tarea",
  "tareas",
  "tarifa",
  "tarifas",
  "tarjeta",
  "tarjetas",
  "tarragona",
  "tasa",
  "tasas",
  "taxi",
  "taza",
  "tazas",
  "teatral",
  "teatro",
  "teatros",
  "techo",
  "tejido",
  "tejidos",
  "tela",
  "telas",
  "tele",
  "telecomunicaciones",
  "telescopio",
  "televisivo",
  "televisor",
  "tema",
  "temas",
  "temblor",
  "teme",
  "temen",
  "temer",
  "temo",
  "temor",
  "temores",
  "temperatura",
  "temperaturas",
  "templo",
  "templos",
  "temporada",
  "temporadas",
  "temporal",
  "temporales",
  "temprana",
  "temprano",
  "tendencia",
  "tendencias",
  "tendido",
  "tendremos",
  "tenemos",
  "tener",
  "tenerife",
  "tenga",
  "tengamos",
  "tengan",
  "tengo",
  "tenido",
  "teniendo",
  "teniente",
  "tenis",
  "tenor",
  "tensiones",
  "terapia",
  "tercer",
  "tercera",
  "tercero",
  "terceros",
  "tercio",
  "teresa",
  "termina",
  "terminaba",
  "terminada",
  "terminado",
  "terminal",
  "terminan",
  "terminar",
  "terminaron",
  "termine",
  "ternura",
  "terraza",
  "terremoto",
  "terreno",
  "terrenos",
  "terrestre",
  "terrestres",
  "terrible",
  "terribles",
  "territorial",
  "territoriales",
  "territorio",
  "territorios",
  "terror",
  "terrorismo",
  "terrorista",
  "terroristas",
  "tesis",
  "tesoro",
  "test",
  "testamento",
  "testigo",
  "testigos",
  "testimonio",
  "testimonios",
  "texas",
  "texto",
  "textos",
  "textura",
  "thomas",
  "tibia",
  "tiempo",
  "tiempos",
  "tienda",
  "tiendas",
  "tiende",
  "tienden",
  "tiene",
  "tienen",
  "tienes",
  "tierno",
  "tierra",
  "tierras",
  "tigre",
  "timbre",
  "times",
  "tinieblas",
  "tinta",
  "tipo",
  "tipos",
  "tira",
  "tirado",
  "tirar",
  "tiro",
  "tiros",
  "tito",
  "titulada",
  "titulado",
  "titular",
  "titulares",
  "toca",
  "tocaba",
  "tocado",
  "tocando",
  "tocar",
  "toda",
  "todas",
  "todo",
  "todos",
  "tokio",
  "toledo",
  "tolerancia",
  "toma",
  "tomaba",
  "tomada",
  "tomadas",
  "tomado",
  "tomamos",
  "toman",
  "tomando",
  "tomar",
  "tomaron",
  "tomarse",
  "tomas",
  "tomate",
  "tomates",
  "tome",
  "tomen",
  "tomo",
  "toneladas",
  "tono",
  "tonos",
  "tonta",
  "tonto",
  "tony",
  "tope",
  "toque",
  "toreo",
  "torero",
  "toreros",
  "tormenta",
  "torneo",
  "torno",
  "toro",
  "toros",
  "torpe",
  "torre",
  "torres",
  "tortura",
  "tos",
  "total",
  "totales",
  "totalidad",
  "totalmente",
  "tour",
  "trabaja",
  "trabajaba",
  "trabajaban",
  "trabajado",
  "trabajador",
  "trabajadores",
  "trabajan",
  "trabajando",
  "trabajar",
  "trabajo",
  "trabajos",
  "tradicional",
  "tradicionales",
  "tradicionalmente",
  "tradiciones",
  "traduce",
  "trae",
  "traen",
  "traer",
  "tragedia",
  "trago",
  "traje",
  "trajes",
  "trajo",
  "trama",
  "tramo",
  "tramos",
  "trampa",
  "trance",
  "tranquila",
  "tranquilidad",
  "tranquilo",
  "tranquilos",
  "transacciones",
  "transcurrido",
  "transcurso",
  "transferencia",
  "transferencias",
  "transforma",
  "transformaciones",
  "transformado",
  "transformar",
  "transmite",
  "transmitir",
  "transparencia",
  "transparente",
  "transporte",
  "transportes",
  "trapo",
  "tras",
  "trascendencia",
  "trasladado",
  "trasladar",
  "traslado",
  "trastorno",
  "trastornos",
  "trata",
  "trataba",
  "tratado",
  "tratados",
  "tratamiento",
  "tratamientos",
  "tratan",
  "tratando",
  "tratar",
  "tratara",
  "trataron",
  "tratarse",
  "trate",
  "trato",
  "tratos",
  "trayecto",
  "trayectoria",
  "trazado",
  "trece",
  "tregua",
  "treinta",
  "tremenda",
  "tremendo",
  "tren",
  "trenes",
  "tres",
  "trescientos",
  "tribu",
  "tribuna",
  "tribunal",
  "tribunales",
  "tributaria",
  "trigo",
  "trimestre",
  "trinidad",
  "triple",
  "triste",
  "tristes",
  "tristeza",
  "triunfo",
  "triunfos",
  "trofeo",
  "tronco",
  "trono",
  "tropa",
  "tropas",
  "tropical",
  "trozo",
  "trozos",
  "trujillo",
  "tubo",
  "tubos",
  "tumba",
  "tumor",
  "tumores",
  "turco",
  "turismo",
  "turista",
  "turistas",
  "turno",
  "tuve",
  "tuviera",
  "tuvieran",
  "tuvieron",
  "tuvimos",
  "tuvo",
  "tuya",
  "tuyo",
  "tve",
  "ubicada",
  "ubicado",
  "ugt",
  "ulises",
  "umbral",
  "unai",
  "unanimidad",
  "unas",
  "unen",
  "unesco",
  "unida",
  "unidad",
  "unidades",
  "unidas",
  "unido",
  "unidos",
  "uniforme",
  "uniformes",
  "unir",
  "unirse",
  "universal",
  "universales",
  "universidad",
  "universidades",
  "universitaria",
  "universitario",
  "universitarios",
  "universo",
  "unos",
  "urbana",
  "urbanas",
  "urbanismo",
  "urbano",
  "urbanos",
  "urgencia",
  "urgencias",
  "urgente",
  "urnas",
  "urss",
  "uruguay",
  "uruguayo",
  "usa",
  "usaba",
  "usado",
  "usados",
  "usan",
  "usando",
  "usar",
  "usos",
  "usted",
  "ustedes",
  "usuario",
  "usuarios",
  "utilidad",
  "utiliza",
  "utilizada",
  "utilizadas",
  "utilizado",
  "utilizados",
  "utilizan",
  "utilizando",
  "utilizar",
  "utilizarse",
  "uva",
  "uxue",
  "vaca",
  "vacaciones",
  "vacas",
  "vacuna",
  "vale",
  "valencia",
  "valenciana",
  "valenciano",
  "validez",
  "valiente",
  "valioso",
  "valladolid",
  "valle",
  "valles",
  "valor",
  "valorar",
  "valores",
  "vamos",
  "vanguardia",
  "vano",
  "vapor",
  "varela",
  "vargas",
  "variable",
  "variables",
  "variaciones",
  "variada",
  "variadas",
  "variado",
  "variados",
  "variante",
  "variantes",
  "variar",
  "varias",
  "variedad",
  "variedades",
  "varios",
  "varones",
  "vasca",
  "vasco",
  "vascos",
  "vaso",
  "vasos",
  "vaticano",
  "vaya",
  "vayan",
  "vayas",
  "veamos",
  "vean",
  "veces",
  "vecina",
  "vecino",
  "vecinos",
  "vega",
  "vegetal",
  "vegetales",
  "veinte",
  "veinticinco",
  "veinticuatro",
  "vejez",
  "vela",
  "velada",
  "velas",
  "velasco",
  "velo",
  "velocidad",
  "vemos",
  "venas",
  "vencedor",
  "vencer",
  "vencido",
  "vende",
  "vendedor",
  "vendedores",
  "venden",
  "vender",
  "vendido",
  "venecia",
  "veneno",
  "venezolana",
  "venezolano",
  "venezolanos",
  "venezuela",
  "venga",
  "vengan",
  "venganza",
  "vengo",
  "venido",
  "venir",
  "venta",
  "ventaja",
  "ventajas",
  "ventana",
  "ventanas",
  "ventanilla",
  "ventas",
  "ventura",
  "venus",
  "ver",
  "vera",
  "veracruz",
  "verano",
  "veras",
  "verbal",
  "verbo",
  "verdad",
  "verdadera",
  "verdaderamente",
  "verdaderas",
  "verdadero",
  "verdaderos",
  "verdades",
  "verde",
  "verdes",
  "verduras",
  "veremos",
  "verificar",
  "verla",
  "verle",
  "verlo",
  "verlos",
  "verme",
  "verse",
  "versiones",
  "verso",
  "versos",
  "verte",
  "vertical",
  "vertiente",
  "vestida",
  "vestido",
  "vestidos",
  "vestir",
  "vestuario",
  "vete",
  "veterano",
  "vez",
  "viabilidad",
  "viable",
  "viaja",
  "viajar",
  "viaje",
  "viajero",
  "viajeros",
  "viajes",
  "vial",
  "vicenta",
  "vicente",
  "vicepresidente",
  "viceversa",
  "vicio",
  "vicios",
  "victoria",
  "victorias",
  "vida",
  "vidal",
  "vidas",
  "video",
  "vidrio",
  "vieja",
  "viejas",
  "viejo",
  "viejos",
  "viena",
  "viendo",
  "viene",
  "vienen",
  "viento",
  "vientos",
  "vientre",
  "viera",
  "viernes",
  "vieron",
  "vietnam",
  "vigencia",
  "vigente",
  "vigentes",
  "vigilancia",
  "vigilar",
  "vigo",
  "vigor",
  "vih",
  "villa",
  "villanueva",
  "vimos",
  "vinagre",
  "vinculada",
  "vinculadas",
  "vinculado",
  "vinculados",
  "vinieron",
  "vino",
  "vinos",
  "violaciones",
  "violencia",
  "violenta",
  "violento",
  "violentos",
  "violeta",
  "virgen",
  "virginia",
  "virtual",
  "virtud",
  "virtudes",
  "virus",
  "visible",
  "visibles",
  "visiones",
  "visita",
  "visitante",
  "visitantes",
  "visitar",
  "visitas",
  "vista",
  "vistas",
  "viste",
  "visto",
  "visual",
  "visuales",
  "vital",
  "vitales",
  "vitalidad",
  "vitamina",
  "vitaminas",
  "vitoria",
  "viuda",
  "viva",
  "vivas",
  "vive",
  "viven",
  "vivido",
  "vivienda",
  "viviendas",
  "viviendo",
  "vivimos",
  "vivir",
  "vivo",
  "vivos",
  "vizcaya",
  "vladimir",
  "vocal",
  "vocales",
  "vocero",
  "voces",
  "volante",
  "volar",
  "volumen",
  "voluntad",
  "voluntaria",
  "voluntariamente",
  "voluntario",
  "voluntarios",
  "volver",
  "volverse",
  "volviendo",
  "volviera",
  "volvieron",
  "vosotros",
  "votantes",
  "votar",
  "voto",
  "votos",
  "voz",
  "vuelo",
  "vuelos",
  "vuelta",
  "vueltas",
  "vuelto",
  "vuelva",
  "vuelve",
  "vuelven",
  "vuelvo",
  "vuestra",
  "vuestro",
  "vulgar",
  "wall",
  "walter",
  "washington",
  "web",
  "whisky",
  "william",
  "williams",
  "wilson",
  "windows",
  "www",
  "xabier",
  "xavier",
  "xunta",
  "yacimientos",
  "yamina",
  "yasmina",
  "yeltsin",
  "yemas",
  "yendo",
  "yolanda",
  "york",
  "youssef",
  "yugoslavia",
  "yusef",
  "zamora",
  "zapatero",
  "zapatos",
  "zaragoza",
  "zarzuela",
  "zedillo",
  "zona",
  "zonas",
  "zoom",
  "zumo",
];
